<template>
    <div v-wechat-title="title" class="padding5" :style="cssVar">
        <el-row type="flex" align="middle">
            <el-col :md="4" :xl="3" class="align-left">
                <span class="hidden-md-and-down">项目类别：</span>
                <item-input type="select" v-model="charge_item_type" :options="charge_item_types" placeholder="项目类别" style="display: inline-block; width: 110px" :clearable="true"></item-input>
            </el-col>
            <el-col :md="3" :xl="2" class="align-left">
                <span class="hidden-md-and-down">类型：</span>
                <item-input type="select" v-model="fee_type" :options="sys_enums.FeeType" placeholder="类型" style="display: inline-block; width: 80px" :clearable="true"></item-input>
            </el-col>
            <el-col :md="4" :xl="3" class="align-left">
                <span class="hidden-md-and-down">状态：</span>
                <item-input type="select" v-model="status" :options="sys_enums.ChargeStatus" placeholder="状态" style="display: inline-block; width: 120px" :clearable="true"></item-input>
            </el-col>
            <el-col :md="13" :xl="16" class="align-right">
                <el-button :type="!this.expeditedStatus ? 'primary' : 'danger' " size="mini" v-if="this.permissions && this.permissions.findIndex(item => item.permission === `charge:expedited`) != -1" @click="changeExpeditedBtnName">  {{ !this.expeditedStatus ? '加急收费' : '取消加急' }}</el-button
                >
                <el-button type="primary" size="mini" v-if="this.permissions && this.permissions.findIndex(item => item.permission === `charge:mzjf_approval`) != -1" @click="changeApprovalBtnName">
                    {{ !this.approvalStatus ? '审核' : '取消审核' }}</el-button
                >
                <el-dropdown v-if="!queryChargeItemTypeIds && this.mzjfPrintBtnName != '0' || this.mzjfPrintAllBtnName != '0'" @command="print">
                    <el-button type="primary" size="mini" v-show="mzjfPrint()">打印<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="printChargeItems">{{ this.mzjfPrintBtnName }}</el-dropdown-item>
                        <el-dropdown-item command="printChargeAllItems">{{ this.mzjfPrintAllBtnName }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-button v-show="!queryChargeItemTypeIds" type="primary" size="mini" @click="printChargeItems" v-if="this.mzjfPrintBtnName != '0' && this.mzjfPrintAllBtnName == '0'">{{ this.mzjfPrintBtnName }}</el-button>
                <el-button v-show="!queryChargeItemTypeIds" type="primary" size="mini" @click="printChargeAllItems()" v-if="this.mzjfPrintBtnName == '0' && this.mzjfPrintAllBtnName != '0'">{{ this.mzjfPrintAllBtnName }}</el-button>
                <el-button v-show="queryChargeItemTypeIds" type="primary" size="mini" @click="printByChargeItemType()">打印</el-button>
                <span v-if="this.mzjfPrintBtnName != '0' || this.mzjfPrintAllBtnName != '0'">&nbsp;|</span>
                <el-button type="primary" :disabled="approvalStatus" size="mini" @click="syncUseDrug"> {{ T(`charge.sync_usedrug`) }}</el-button>
                <el-button type="primary" size="mini" @click="refreshChargeItems">刷新</el-button><span>&nbsp;|</span>
                <el-button type="primary" size="mini" @click="SaveAsTemplate" v-if="this.permissions && this.permissions.findIndex(item => item.permission === `charge:save_astmpmzjf`) != -1"
                    >另存为模板</el-button
                >
                <el-button type="primary" size="mini" @click="loadTemplatesView" v-if="this.permissions && this.permissions.findIndex(item => item.permission === `charge:extract_tmpmzjf`) != -1"
                    >提取模板</el-button
                >
                <span v-if="this.permissions && this.permissions.findIndex(item => item.permission === `charge:kkc` || item.permission === `charge:qxkkc`) != -1">&nbsp;</span>
                <el-button
                    type="primary"
                    size="mini"
                    v-if="isQueryDrugType && this.permissions && this.permissions.findIndex(item => item.permission === `charge:kkc`) != -1"
                    @click="saveInventory(1)"

                    >扣库存</el-button
                >
                <el-button
                    type="primary"
                    size="mini"
                    v-if="isQueryDrugType && this.permissions && this.permissions.findIndex(item => item.permission === `charge:qxkkc`) != -1"
                     @click="saveInventory(2)"
                    >取消扣库存</el-button
                >
                <span v-if="this.permissions && this.permissions.findIndex(item => item.permission === `charge:save_astmpmzjf` || item.permission === `charge:extract_tmpmzjf`) != -1">&nbsp;</span>
                <el-button
                    type="primary"
                    :disabled="approvalStatus"
                    size="mini"
                    @click="sendHis"
                    v-if="this.permissions && this.permissions.findIndex(item => item.permission === `charge:sendmzjf`) != -1"
                    >发送</el-button
                >
                <el-button type="primary" :disabled="approvalStatus" size="mini" @click="withdrawHis" v-if="this.isOpenSHFlow == '1'">撤销</el-button>
                <el-button
                    type="primary"
                    :disabled="approvalStatus"
                    size="mini"
                    @click="loadReturnCharges"
                    v-if="this.permissions && this.permissions.findIndex(item => item.permission === `charge:tfmzjf`) != -1"
                    >退费</el-button
                ><span>&nbsp;|</span>
                <el-button
                    type="primary"
                    :disabled="approvalStatus"
                    size="mini"
                    @click="saveItems"
                    v-if="this.permissions && this.permissions.findIndex(item => item.permission === `charge:savemzjf`) != -1"
                    >保存</el-button
                >
                <el-dropdown @command="loadDocument" v-if="this.permissions && this.permissions.findIndex(item => item.permission === `charge:sysview`) != -1">
                    <el-button type="primary" size="mini">查看单据<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="item.enum_record_type" :key="index" v-for="(item, index) in loadDocumentListButton">{{ item.record_type }}</el-dropdown-item>
                        <el-dropdown-item :command="0" key="h0">合并记录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

                <!-- <el-button type="primary" size="mini" @click="loadDocument(1)">查看麻醉单</el-button>
                <el-button type="primary" size="mini" @click="loadDocument(2)">查看复苏单</el-button> -->
                <el-popover placement="bottom" :open-delay="600">
                    <el-button size="mini" plain slot="reference">
                        <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
                        <span class="hidden-md-and-down">&nbsp;列配置</span>
                    </el-button>
                    <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 250px; width: max-content">
                        <div class="config-column">
                            <item-input type="checkboxgroup" :options="configColumns" v-model="user_config_columns"></item-input>
                        </div>
                    </el-scrollbar>

                    <el-divider></el-divider>
                    <div style="text-align: right">
                        <el-link type="primary" size="mini" class="margin-right10" @click="SaveUserColumns">保存</el-link>
                    </div>
                </el-popover>
            </el-col>
        </el-row>
        <!-- 默认 -->
        <el-row class="margin5 margin-none-h" v-show="!this.showRemarksColumnConfig">
            <el-col :lg="10" :md="6" class="align-left">
                <span class="hidden-md-and-down">麻醉方式：</span>
                {{
                    (this.surgeryInfo.fact_anaes_methods && this.surgeryInfo.fact_anaes_methods.length > 0 && this.surgeryInfo.fact_anaes_methods.map(d => d.label).toString()) ||
                    (this.currentSurgery && this.currentSurgery.anaes_methods) ||
                    '--'
                }}
            </el-col>
            <el-col :md="6" :lg="3" class="align-left"> 时长：{{ this.anesTotal }} </el-col>
            <el-col :lg="10" :md="6" class="align-left" v-if="this.chargeType == 0">
                <span class="hidden-md-and-down">手术名称：</span>
                {{ (this.currentSurgery && this.currentSurgery.surgeries) || '--' }}
            </el-col>
            <el-col :lg="3" class="align-left" v-if="this.chargeType == 0"> 时长：{{ this.surgeryTotal }} </el-col>
            <el-col :lg="2" class="align-left">
                <el-tag :type="surgeryInfo.enum_surgery_type == 1 ? 'danger' : 'primary'" size="mini" v-if="surgeryInfo.enum_surgery_type">{{ surgeryInfo.surgery_type }}</el-tag>
            </el-col>
            <el-col :lg="3" class="align-left"> 类别： {{ (surgeryInfo.visit_info && surgeryInfo.visit_info.pay_type) || '--' }} </el-col>
        </el-row>
        <!-- 存储配置 -->
        <el-row class="margin5 margin-none-h" v-html="this.remarksColumn" v-show="this.showRemarksColumnConfig"></el-row>
        <el-row class="margin5 margin-none-h">
            <el-col :lg="8" class="align-left" v-show="chargeScanConfig && chargeScanConfig!==``">
                <span v-if="!queryChargeItemTypeIds || !isQueryDrugType" class="hidden-md-and-down">高值耗材：</span>
                <item-input
                    ref="scan-code"
                    size="mini"
                    type="scan"
                    v-model="scancode"
                    placeholder="请扫码/输入条形码"
                    style="display: inline-block; width: 200px"
                    :autofocus="true"
                    @input="scanCharge"
                ></item-input>
            </el-col>
            <el-col :lg="this.count" class="align-right" style="font-weight: bold">计费条数:{{ this.totalCount }}</el-col>
            <el-col :lg="4" class="align-right" style="font-weight: bold" :title="titleLabel()" v-if="this.mzjfclassification != '1'"> 已计费用:{{ this.totalPrice }} </el-col>
            <el-col :lg="8" class="align-right" style="font-weight: bold" :title="titleLabel()" v-if="this.mzjfclassification == '1'">
                <span v-if="!queryChargeItemTypeIds || isQueryDrugType">药品:{{ this.drugsPrice }}</span>&nbsp;<span v-if="!queryChargeItemTypeIds || !isQueryDrugType">非药品:{{ this.otherPrice }}</span>&nbsp;已计费用:{{ this.totalPrice }}
            </el-col>
            <el-col :lg="4" class="align-right" style="color: red; font-weight: bold">已退费用:{{ this.tfPrice }}</el-col>
        </el-row>
        <list-view
            :showSequence="true"
            :selection="chargeRefundType == 2"
            @changeColWidth="changeColWidth"
            ref="supplies-list"
            :datalist="datalist"
            :tableHeight="this.screenHeight - (this.chargeType == 0 ? 260 : 230) - (this.hasNodes ? 35 : 0)"
            :headerStyle="tableheaderStyle"
            :chargeStyle="true"
            :stripe="false"
            @extrabutton-click="ExtraButtonClick"
            :columns="userListColumn"
            :buttons="[]"
        >
            <span slot="enum_charge_status" slot-scope="{ row }">
                <i v-if="row.enum_charge_status == 1" :class="{ 'el-icon-circle-check': true, 'fg-primary': row.enum_fee_type == 1, 'fg-danger': row.enum_fee_type == -1 }"> </i>
                <i v-else-if="row.enum_charge_status == 2" :class="{ 'el-icon-circle-close': true, 'fg-primary': row.enum_fee_type == 1, 'fg-danger': row.enum_fee_type == -1 }"></i>
                <i v-else-if="row.enum_charge_status == -1" :class="{ 'el-icon-loading': true, 'fg-primary': row.enum_fee_type == 1, 'fg-danger': row.enum_fee_type == -1 }"></i>
                <i v-else> </i>
            </span>
            <div slot="charge_status" class="ellipsis" slot-scope="{ row }">
                <div
                    style="white-space: normal"
                    :style="
                        Object.keys(chargeStatusBgColorObj).length > 0 && chargeStatusBgColorObj[row.enum_charge_status] ? 'background-color:' + chargeStatusBgColorObj[row.enum_charge_status] : ''
                    "
                >
                    {{ row.charge_status }}
                </div>
            </div>
            <div slot="custom_is_deducted_inventory" class="ellipsis" slot-scope="{ row }">
                <div
                    style="white-space: normal"
                    :style="row.is_deducted_inventory==true? 'background-color:rgb(95, 219, 101)' :'background-color:rgb(74, 112, 187)'"
                >
                    {{ row.is_deducted_inventory==true?'是':'否' }}
                </div>
            </div>

        </list-view>
        <form-dialog
            ref="form-saveas"
            title="另存为模板"
            :data="saveas.data"
            width="25%"
            class="form-table-h360"
            :visible.sync="saveas.dialogFormVisible"
            :columns="saveAsColumnList"
            @confirm="SaveAsConfirm"
        ></form-dialog>
        <cus-dialog class="form-table-h500" title="提取模板" :visible.sync="collectCharges.dialogFormVisible" :close-on-click-modal="false" width="80%" @confirm="addTemplateToList">
            <div v-if="this.charge_template_group && this.charge_template_group.length > 0" :style="{ position: 'relative' }">
                <el-row>
                    <el-col :span="8" class="padding5" style="display: flex; justify-content: flex-start; line-height: 100%">
                        <span style="display: inline-block; width: 30%; line-height: 90%; word-wrap: break-word; white-space: normal; text-align: left">可用范围：</span>
                        <item-input type="radio" v-model="region_type" :options="hasRegionTypePermission"></item-input>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="padding5" style="display: flex; justify-content: flex-start; line-height: 100%">
                        <item-input type="string1" v-model="region_searchKey" placeholder="请输入关键字" :autofocus="true" @keyup.enter.native="loadTemplatesView"></item-input>
                        <el-button type="primary" size="mini" @click="loadTemplatesView">搜索</el-button>
                    </el-col>
                </el-row>
                <el-row style="min-height: 580px">
                    <el-col :span="4">
                        <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 570px; background: white">
                            <el-tree
                                ref="tree"
                                :data="templateTree.data"
                                :props="templateTree.defaultProps"
                                :node-key="templateTree.defaultProps.value"
                                check-on-click-node
                                :default-expand-all="false"
                                @check="handleNodeClick"
                            >
                                <span class="custom-tree-node" title="node.label" slot-scope="{ node, data }"
                                    ><span :title="node.label" :style="{ color: data.is_recovery_template ? '#52b8d2' : '' }">{{ node.label }}</span>
                                </span>
                            </el-tree>
                        </el-scrollbar>
                    </el-col>
                    <el-col :span="20">
                        <list-view
                            ref="collectChargeslist"
                            :columns="collectCharges.columnList"
                            :datalist="collectCharges.datalist"
                            :selectAll="true"
                            :selection="true"
                            :tableHeight="580"
                            @extrabutton-click="ExtraButtonClick"
                            :showSequence="false"
                        ></list-view>
                    </el-col>
                </el-row>
            </div>
            <div class="table-h360" v-else>
                <div class="padding20 align-left">
                    <span class="line-height35">请选模板:</span>
                    <item-input
                        type="groupselect"
                        :collapseTags="false"
                        v-model="collectCharges.selected_template"
                        :options="collectCharges.charge_template"
                        :clearable="true"
                        style="display: inline-block; width: 300px"
                    ></item-input>
                </div>
                <list-view
                    ref="collectChargeslist"
                    :columns="collectCharges.columnList"
                    :datalist="collectCharges.datalist"
                    :selectAll="true"
                    :selection="true"
                    @extrabutton-click="ExtraButtonClick"
                    :showSequence="false"
                ></list-view>
            </div>
        </cus-dialog>
        <cus-dialog class="table-h360" title="退费" :visible.sync="returnChargesView.dialogFormVisible" :close-on-click-modal="false" width="60%" @confirm="returnCharges">
            <list-view :columns="returnChargesColumns" :datalist="returnChargesView.datalist"></list-view>
        </cus-dialog>
        <pdf-frame :base64="base64" :visible.sync="pdfvisible" :title="typeTitle" :modal="false"></pdf-frame>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Sortable from 'sortablejs'
import { getScreensData, openNewWindow, isMultiScreen } from '@/common/OpenWindowExpand.js'
export default {
    name: `Charge`,
    props: {},
    data() {
        return {
            scancode: ``,
            isMultiScreen: false,
            setMultiScreen: [],
            basepdf: ``,
            loadDocumentListButton: [],
            base64: ``,
            pdfvisible: false,
            typeTitle: ``,
            hasNodes: false,
            expeditedStatus: false,
            title: this.$route.query.charge_type == 1 ? `麻醉计费` : `手术计费`,
            chargeType: this.$route.query.charge_type || 1,
            surgeryId: this.$route.query.surgery_id,
            token: this.$route.query.token,
            isOpenSHFlow: this.$root.IsOpenSHFlow,
            record_type: this.$route.query.record_type,
            charge_item_type: ``,
            charge_item_types: [],
            status: ``,
            fee_type: ``,
            datalist: [],
            surgeryInfo: {},
            chargeStatusBgColor: this.$root.ChargeStatusBgColor,
            chargeStatusBgColorObj: {},
            chargeListStyle: this.$root.chargeListStyle,
            chargeListStyleObj: {},
            chrgItemTypesColorObj: {},
            mzjfPrintBtnName: this.$root.MZJFPrintBtnName,
            approvalStatus: false,
            mzjfPrintAllBtnName: this.$root.MZJFPrintAllBtnName,
            configdefaultPayType: this.$root.DefaultPayType,
            sendJfType: this.$root.SendJfType,
            mzjfclassification: this.$root.mzjfclassification || 0,
            chargeItemSelectConfig: this.$root.ChargeItemSelectConfig || 0,
            checkedRow: [],
            permissions: [],
            collectCharges: {
                dialogFormVisible: false,
                selected_template: undefined,
                charge_template: [],
                cache_template: {},
                datalist: [],
                columnList: [
                    {
                        type: `string`,
                        prop: `display_order`,
                        label: `排序`,
                        width: `80`,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `id`,
                        label: `编号`,
                        width: `80`,
                        isKey: true,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `dic_chrg_item_name`,
                        label: `项目名称`,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `spec`,
                        label: `规格`,
                        width: `180`,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `firm`,
                        label: `厂家`,
                        width: `180`,
                        isListable: true
                    },
                    {
                        type: `float`,
                        prop: `amount`,
                        label: `计费数量`,
                        width: `80`,
                        readonly: false,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `sell_unit`,
                        label: `计价单位`,
                        width: `60`,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `price`,
                        label: `单价（元）`,
                        width: `80`,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `total_price`,
                        label: `计费金额`,
                        width: `80`,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `dic_chrg_item_type_name`,
                        label: `项目类别`,
                        width: `80`,
                        isListable: true
                    }
                ]
            },
            returnChargesView: {
                dialogFormVisible: false,
                datalist: []
            },
            drug_section_id: 0,
            item_configs: [],
            drug_section: {
                id: 0,
                name: undefined
            },
            saveas: {
                dialogFormVisible: false,
                data: {}
            },
            isDrugChargeItemShow: this.$root.isDrugChargeItemShow || 0,
            isDrugAlert: this.$root.isDrugChargeItemShow && this.$root.isDrugChargeItemShow != 0,
            configColumns: [],
            user_config_columns: [],
            user_config_columns2: [],
            default_pay_type: null,
            default_anes_section_id: null,
            default_anes_section: null,
            default_drug_section_id: null,
            default_drug_section: null,
            default_section_id: null,
            default_section: null,
            default_doctor: null,
            chargeRefundType: 2, // 默认批量退
            syncUseDrugIn: false, // 标记是否点击药品同步按钮
            templateIn: false, // 标记是否点击提取模板按钮
            charge_template_selected: false, // 计费模板是否选中
            charge_template_group: this.$root.ChargeTemplateGroup && this.$root.ChargeTemplateGroup != `` && JSON.parse(this.$root.ChargeTemplateGroup) || [],
            templateTree: {
                data: [],
                defaultProps: {
                    value: `value`,
                    children: `children`,
                    label: `label`,
                    parentValue: `parent_value`
                }
            },
            tableName: `api_Nursing/Charge`,
            region_type: 2,
            issetoperatingward: false,
            amountOverNum: 1000,
            chargeScanConfig: (this.$root.carte_ChargeScan && this.$root.carte_ChargeScan != `0`) ? this.$root.carte_ChargeScan : ``,
            autoInputBillDept: this.$root.AutoInputBillDept, // 选择开单科室时 是否把当前选择的值 覆盖到页面其它数据行上,0:不处理,1:把当前选中的值覆盖到其它未保存的数据行,2:覆盖 未发送的 数据行
            autoInputDoctor: this.$root.AutoInputDoctor, // 选择开单人时 是否把当前选择的值 覆盖到页面其它数据行上,0:不处理,1:把当前选中的值覆盖到其它未保存的数据行,2:覆盖 未发送的 数据行
            defaultPrevRow: this.$root.DefaultPrevRow,
            showRemarksColumnConfig: this.$root.ChargeRemarksColumnConfig && this.$root.ChargeRemarksColumnConfig != `` || false,
            remarksColumn: ``, // 备注栏信息
            charge_Total_Decimaldigits: this.$root.charge_Total_Decimaldigits || 2, // 自定义计费金额小数位数
            amountOverColorInfo: {},
            region_searchKey: ``,
            // 0-编码,1-规格,2-价格,3-单位,4-厂商,5-统一收费编码,6-医保类型,7-库存,8-描述
            chargeColumns: [
                { prop: `code`, label: `编码`, minWidth: 150, id: `0` },
                { prop: `spec`, label: `规格`, minWidth: 100, id: `1` },
                { prop: `price`, label: `价格`, minWidth: 80, id: `2` },
                { prop: `sell_unit`, label: `单位`, minWidth: 80, id: `3` },
                { prop: `firm`, label: `厂商`, minWidth: 120, id: `4` },
                { prop: `uni_charge_code`, label: `收费编码`, minWidth: 100, id: `5` },
                { prop: `medical_type`, label: `医保`, minWidth: 80, id: `6` },
                { prop: `inventory`, label: `库存`, minWidth: 80, id: `7` },
                { prop: `description`, label: `描述`, minWidth: 100, id: `8` }
            ],
            onlySimpleWard: this.$root.OnlySimpleWard,
            queryChargeItemTypeIds: this.$route.query.charge_item_types && this.$route.query.charge_item_types.split(`,`).map(i => parseInt(i)),
            chargeItemTypePrintSetting: this.$root.ChargeItemTypePrintSetting,
            isConsumableUniqueCode: this.$root.IsConsumableUniqueCode || `0`,
            chargeItemAddConfig: this.$root.ChargeItemAddConfig || `1`,
            themeVersion: 0,
            themeObserver: null
        }
    },
    computed: {
        ...mapGetters([`ward_auth`, `currentUser`, `recovery_ward_all`, `screenHeight`, `active_ward`, `sys_enums`, `currentSurgery`, `section_auth`, `sysuser/workers_by_duty`, `drug/drug_way`]),
        worker() {
            return this[`sysuser/workers_by_duty`]
        },
        isQueryDrugType() {
            let defaultNoFilter = true
            if (this.queryChargeItemTypeIds) {
                defaultNoFilter = this.queryChargeItemTypeIds && this.queryChargeItemTypeIds.includes(1)
            }
            return defaultNoFilter
        },
        cssVar() {
            const isHisBlue = this.isHisBlueThemeActive(this.themeVersion)
            if (this.chargeListStyle != ``) {
                let ls = eval(`(` + this.chargeListStyle + `)`)
                this.chargeListStyleObj = ls
            }
            const defaultRowBg = isHisBlue ? `#FFFFFF` : `var(--table-row-hover-bg, #cdeae8)`
            const defaultHoverRowBg = isHisBlue ? `var(--table-row-hover-bg, #E1EFFD)` : `var(--table-row-hover-bg, #cdeae8)`
            let rowStyleInfo = (this.chargeListStyleObj && this.chargeListStyleObj.row) || { color: `#000000`, background: defaultRowBg }
            rowStyleInfo = Object.assign({ background: defaultRowBg }, rowStyleInfo)
            if (!rowStyleInfo.background && rowStyleInfo.backgroundColor) {
                rowStyleInfo.background = rowStyleInfo.backgroundColor
            }
            // hover 进入时行样式
            let hoverRowStyleInfo = (this.chargeListStyleObj && this.chargeListStyleObj.hoverRow) || { color: `#000000`, background: defaultHoverRowBg }
            hoverRowStyleInfo = Object.assign({ background: defaultHoverRowBg }, hoverRowStyleInfo)
            if (!hoverRowStyleInfo.background && hoverRowStyleInfo.backgroundColor) {
                hoverRowStyleInfo.background = hoverRowStyleInfo.backgroundColor
            }
            if (isHisBlue) {
                rowStyleInfo = Object.assign({}, rowStyleInfo, { background: defaultRowBg })
                hoverRowStyleInfo = Object.assign({}, hoverRowStyleInfo, { background: defaultHoverRowBg })
            }
            // chrgItemType样式
            let chrgItemTypesColor = this.chargeListStyleObj && this.chargeListStyleObj.chrgItemType
            this.chrgItemTypesColorObj = chrgItemTypesColor
            // 字段校验样式
            let checkFieldsColor = (this.chargeListStyleObj && this.chargeListStyleObj.checkFields) || { amountZeroColor: `#FCA4A4`, payTypeNullColor: `#AAA2FE`, amountOverColor: `1000|#FF0000` }
            let amountOverinfo = checkFieldsColor && checkFieldsColor.amountOverColor && checkFieldsColor.amountOverColor.split(`|`)
            let amountOverColor = `#FF0000`
            if (amountOverinfo && amountOverinfo.length == 2) {
                this.amountOverNum = parseInt(amountOverinfo[0])
                amountOverColor = amountOverinfo && amountOverinfo[1]
            }

            // 计费类型数量校验颜色自定义
            let amountOverColorObj = checkFieldsColor && checkFieldsColor.amountOverColorObj
            this.amountOverColorInfo = amountOverColorObj

            var result = {
                '--rowcolor': rowStyleInfo.color,
                '--rowbgcolor': rowStyleInfo.background,
                '--hoverRowcolor': hoverRowStyleInfo.color,
                '--hoverRowbgcolor': hoverRowStyleInfo.background,
                // 计费类型行颜色自定义
                '--YPColor': chrgItemTypesColor && chrgItemTypesColor.YPColor,
                '--ZLColor': chrgItemTypesColor && chrgItemTypesColor.ZLColor,
                '--QTColor': chrgItemTypesColor && chrgItemTypesColor.QTColor,
                '--HYColor': chrgItemTypesColor && chrgItemTypesColor.HYColor,
                '--JCColor': chrgItemTypesColor && chrgItemTypesColor.JCColor,
                '--ZCColor': chrgItemTypesColor && chrgItemTypesColor.ZCColor,
                '--SSColor': chrgItemTypesColor && chrgItemTypesColor.SSColor,
                '--XFColor': chrgItemTypesColor && chrgItemTypesColor.XFColor,
                '--CLColor': chrgItemTypesColor && chrgItemTypesColor.CLColor,
                '--HLColor': chrgItemTypesColor && chrgItemTypesColor.HLColor,
                '--FYPColor': chrgItemTypesColor && chrgItemTypesColor.FYPColor,
                '--HCColor': chrgItemTypesColor && chrgItemTypesColor.HCColor,
                '--GZHCColor': chrgItemTypesColor && chrgItemTypesColor.GZHCColor,
                // 计费类型对应数量颜色自定义
                '--YPAmountColor': amountOverColorObj && amountOverColorObj.YP && amountOverColorObj.YP.color,
                '--ZLAmountColor': amountOverColorObj && amountOverColorObj.ZL && amountOverColorObj.ZL.color,
                '--QTAmountColor': amountOverColorObj && amountOverColorObj.QT && amountOverColorObj.QT.color,
                '--HYAmountColor': amountOverColorObj && amountOverColorObj.HY && amountOverColorObj.HY.color,
                '--JCAmountColor': amountOverColorObj && amountOverColorObj.JC && amountOverColorObj.JC.color,
                '--ZCAmountColor': amountOverColorObj && amountOverColorObj.ZC && amountOverColorObj.ZC.color,
                '--SSAmountColor': amountOverColorObj && amountOverColorObj.SS && amountOverColorObj.SS.color,
                '--XFAmountColor': amountOverColorObj && amountOverColorObj.XF && amountOverColorObj.XF.color,
                '--CLAmountColor': amountOverColorObj && amountOverColorObj.CL && amountOverColorObj.CL.color,
                '--HLAmountColor': amountOverColorObj && amountOverColorObj.HL && amountOverColorObj.HL.color,
                '--DZHCAmountColor': amountOverColorObj && amountOverColorObj.DZHC && amountOverColorObj.DZHC.color,
                '--FYPAmountColor': amountOverColorObj && amountOverColorObj.FYP && amountOverColorObj.FYP.color,
                '--HCAmountColor': amountOverColorObj && amountOverColorObj.HC && amountOverColorObj.HC.color,
                '--GZHCAmountColor': amountOverColorObj && amountOverColorObj.GZHC && amountOverColorObj.GZHC.color,
                // 个性化
                '--DZHCColor': chrgItemTypesColor && chrgItemTypesColor.DZHCColor,
                '--amountZeroColor': checkFieldsColor && checkFieldsColor.amountZeroColor || `#FCA4A4`,
                '--payTypeNullColor': checkFieldsColor && checkFieldsColor.payTypeNullColor || `#AAA2FE`,
                '--amountOverColor': amountOverColor
            }
            console.log(`result`)
            console.log(result)
            return result
        },
        hasRegionTypePermission() {
            let r = []
            if (this.onlySimpleWard != `1`) {
                r.push({ label: `个人`, value: 1 })
            }
            if (_.find(this.permissions, { permission: `tmp:area_read` }) != undefined || _.find(this.permissions, { permission: `tmp:area_edit` }) != undefined || _.find(this.permissions, { permission: `tmp:alltmp` }) != undefined) {
                r.push({ label: `区域`, value: 2 })
            }
            return r
        },
        fromDesptop() {
            // 是客户端 且 从麻醉单/复苏单打开的返回true(从麻醉单上tab页签过来的 获取计费模板的逻辑和 患者 计费那里提取的逻辑不一样)
            let fromDesptop = false
            if (typeof winformMsg != `undefined` && this.token) {
                fromDesptop = true
            }
            return fromDesptop
        },
        // add by xiaorui ACIS-22558
        // 日期：2021-08-16,
        // 功能：当前用户有区域按钮权限，才显示区域 按钮
        wardOptions() {
            let wards = null
            // ACIS-26427 麻烦啊，当 手术申请 source_hospital_ward_id 不为空,需要根据 来源院区过滤 手术区/复苏区
            if (this.surgeryInfo && this.surgeryInfo.source_hospital_ward_id) {
                wards = _.filter(this.ward_auth, ward => ward.groupId == this.surgeryInfo.source_hospital_ward_id)
            } else {
                wards = _.cloneDeep(this.ward_auth)
                // 是否开启单院区过滤
                if (!this.surgeryId && this.onlySimpleWard == `1`) {
                    // 从科室菜单-用药模版来的且 开启单院区过滤,根据右上角单院区来过滤
                    wards = _.filter(wards, ward => ward.groupId == this.active_ward.groupId)
                }
            }
            let r = []
            if (this.recordType == 2) {
                r = _.filter(wards, (d) => {
                    return _.startsWith(d.value, `rw_`) == true
                })
            } else {
                r = _.filter(wards, (d) => {
                    return _.startsWith(d.value, `ow_`) == true
                })
            }
            console.log(`***********************`)
            console.log(r)
            return r
        },
        sectionFidlerHospitalWard() {
            let section = _.cloneDeep(this[`section_auth`])
            console.log(`section`)
            console.log(section)
            if (this.surgeryInfo.source_hospital_ward_id != null && this.surgeryInfo.source_hospital_ward_id != ``) {
                section = section.filter(d => d.alias == this.surgeryInfo.source_hospital_ward_id)
            }
            return section
        },
        columnList() {
            let me = this
            let editfailed = (me.permissions && me.permissions.findIndex(item => item.permission === `charge:edit_failed_item_mzjf`) !== -1)
            return [
                {
                    type: `string`,
                    prop: `___index`,
                    label: `unique`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`
                },
                {
                    type: this.chargeItemSelectConfig == 1 ? `tableselect` : `remoteselect`,
                    // type: {
                    //     0: `remoteselect`,
                    //     1: `remoteselecttable`,
                    //     2: `tableselect`
                    // }[this.chargeItemSelectConfig],
                    prop: `chrg_item`,
                    label: `项目名称`,
                    width: `180`,
                    isListable: true,
                    // tooltip: true,
                    readonly: function(that, { row, area }) {
                        if (area == `list`) {
                            if (row.is_deducted_inventory == 1 || me.chargeItemAddConfig == `0`) {
                                return true
                            } else {
                                if (row.id && row.id > 0 && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2))) {
                                    return true
                                } else {
                                    return false
                                }
                            }
                        }
                        return true
                    },
                    sortable: true,
                    // `api/AcisSystem/ChargeItem/Search`
                    options: (that, { row }) => {
                        return q => {
                            return this.loadChargeItemList(q)
                        }
                    },
                    selectColumn: this.chargeColumns,
                    change: (that, { row, index }) => {
                        if (row.chrg_item && row.chrg_item.value) {
                            let req = this.myaxios.get(`/api/AcisSystem/ChargeItem/Get/${row.chrg_item.value}`)
                            req.then(data => {
                                // 开启特殊用药弹框提示 且 计费项类型是药品 且 药品Remark有值【remark有值表示特殊用药】
                                if (this.isDrugAlert && data.remark && (this.isDrugChargeItemShow == `1` || (this.isDrugChargeItemShow == `2` && (data.is_special_medication || 0) == 1))) {
                                    this.$confirm(`医保中心提示：该项目 【${row.chrg_item.label}】<br/><br/>${data.remark}<br/><br/>选择【是】将设置为医保，【否】将设置为自费，【X】不开立本医嘱`, `医保中心提示`, {
                                        confirmButtonText: `是`,
                                        cancelButtonText: `否`,
                                        distinguishCancelAndClose: true,
                                        dangerouslyUseHTMLString: true,
                                        closeOnClickModal: false
                                    }).then(() => {
                                        this.setRowValue(row, data, 2) // 2=医保
                                    }).catch((action) => {
                                        if (action === `cancel`) {
                                            this.setRowValue(row, data, 3) // 3=自费
                                        } else {
                                            this.row = undefined // 取消添加此行
                                        }
                                    })
                                } else {
                                    this.setRowValue(row, data, null) // 2=医保
                                    if (!row.enum_pay_type) {
                                        this.$set(row, `enum_pay_type`, this.default_pay_type)
                                    }
                                }
                                this.$set(row, `consumables_batch`, ``)
                                this.$set(row, `special_medication_remark`, null)
                                if (data.remark) {
                                    this.$set(row, `special_medication_remark`, data.remark)
                                }
                                this.$set(row, `billing_time`, me.$moment().format(`YYYY/MM/DD HH:mm`))
                            }).catch(e => console.log(e))
                        } else {
                            this.$set(row, `spec`, ``)
                            this.$set(row, `firm`, ``)
                            this.$set(row, `sell_unit`, ``)
                            this.$set(row, `price`, ``)
                            this.$set(row, `dic_chrg_item_type_id`, 0)
                            this.$set(row, `uni_charge_code`, ``)
                            this.$set(row, `limit_price_type`, ``)
                            this.$set(row, `min_price`, ``)
                            this.$set(row, `max_price`, ``)
                            this.$set(row, `remark_msg`, ``)
                            this.$set(row, `dic_add_drug_way_id`, ``)
                            this.$set(row, `consumables_batch`, ``)
                            this.$set(row, `billing_time`, ``)
                        }
                    }
                },
                {
                    type: `select`,
                    prop: `enum_fee_type`,
                    label: `类型`,
                    width: `60`,
                    isListable: true,
                    options: this.sys_enums.FeeType,
                    readonly: true,
                    sortable: true,
                    config: {
                        clearable: false
                    }
                },
                {
                    type: `select`,
                    prop: `enum_charge_status`,
                    label: `状态`,
                    width: `0`,
                    isListable: false,
                    options: this.sys_enums.ChargeStatus
                },
                {
                    type: `custom`,
                    prop: `charge_status`,
                    label: `状态`,
                    isListable: true,
                    sortable: true,
                    width: `80`
                }, {
                    type: `custom`,
                    prop: `custom_is_deducted_inventory`,
                    label: `是否已扣库存`,
                    isListable: true,
                    sortable: true,
                    width: `80`
                },
                {
                    type: `string`,
                    prop: `spec`,
                    label: `规格`,
                    width: `120`,
                    isListable: true,
                    readonly: true
                },
                {
                    type: `string`,
                    prop: `firm`,
                    label: `厂家`,
                    width: `180`,
                    tooltip: true,
                    isListable: true,
                    readonly: true
                },
                {
                    type: `float`,
                    prop: `amount`,
                    label: `计费数量`,
                    width: `85`,
                    isListable: true,
                    sortable: true,
                    readonly: (that, { row }) => {
                        if (row.is_deducted_inventory == 1 || (row.consumables_batch && me.isConsumableUniqueCode == `1`)) {
                            return true
                        } else {
                            return row.enum_charge_status && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2))
                        }
                    },
                    change: (that, { row }) => {
                        row.class_name = me.getRowClassName(row)
                        let realVal = this.$multiplyMaths.multiply(parseFloat(row.price), parseFloat(row.amount)).toNewFixed(this.charge_Total_Decimaldigits)
                        this.$set(row, `total_price`, realVal)
                    }
                },
                {
                    type: `string`,
                    prop: `sell_unit`,
                    label: `计价单位`,
                    width: `80`,
                    isListable: true,
                    readonly: true
                },
                {
                    type: `float`,
                    prop: `price`,
                    label: `单价(元)`,
                    width: `90`,
                    isListable: true,
                    sortable: true,
                    readonly: function(that, { row, area }) {
                        if (row.dic_chrg_item_type_name == `不计费` || !row.limit_price_type || (row.consumables_batch && me.isConsumableUniqueCode == `1`)) {
                            return true
                        }
                        return row.limit_price_type != 1
                    },
                    activereadonly: function(that, { row, area }) {
                        if (row.dic_chrg_item_type_name == `不计费` || !row.limit_price_type || (row.consumables_batch && me.isConsumableUniqueCode == `1`)) {
                            return true
                        }
                        return row.limit_price_type != 1
                    },
                    change: (that, { row }) => {
                        // let realVal = parseFloat((row.price * 10) * (row.amount * 10) / 100).toNewFixed(2)
                        let realVal = this.$multiplyMaths.multiply(parseFloat(row.price), parseFloat(row.amount)).toNewFixed(this.charge_Total_Decimaldigits)
                        this.$set(row, `total_price`, realVal)
                    },
                    blur: (that, { row, index }) => {
                        if (row.dic_chrg_item_type_name == `不计费`) {
                            row.price = 0
                            return
                        }
                        if (row.limit_price_type == 1) {
                            if (row.max_price > 0) {
                                if (row.price > row.max_price) {
                                    row.price = row.max_price
                                    this.$message.warning(`该项目限制单价范围` + row.min_price + `~` + row.max_price)
                                }
                            }
                            if (row.min_price > 0) {
                                if (row.price < row.min_price) {
                                    row.price = row.min_price
                                    this.$message.warning(`该项目限制单价范围` + row.min_price + `~` + row.max_price)
                                }
                            }
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `total_price`,
                    label: `计费金额`,
                    width: `90`,
                    isListable: true,
                    sortable: true,
                    readonly: true
                },
                {
                    type: `select`,
                    prop: `dic_chrg_item_type_id`,
                    label: `项目类别`,
                    width: `100`,
                    isListable: true,
                    readonly: true,
                    sortable: true,
                    options: this.charge_item_types,
                    // 自定义排序
                    sortChange: function(that, { a, b, prop, column }) {
                        let thisObj = that.$parent
                        let str1 = a[prop]
                        if (!str1) return 1
                        let str2 = b[prop]
                        if (!str2) return -1
                        let dis1Number = thisObj.DisplayOrderNumber(str1)
                        let dis2Number = thisObj.DisplayOrderNumber(str2)
                        return dis1Number - dis2Number
                    },
                    config: {
                        clearable: false
                    }
                },
                {
                    type: `select`,
                    prop: `dic_add_drug_way_id`,
                    label: `用药途径`,
                    width: `120`,
                    isListable: true,
                    options: this[`drug/drug_way`],
                    readonly: (that, { row }) => {
                        if (row.is_deducted_inventory == 1) {
                            return true
                        } else {
                            return row.enum_charge_status && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2)) || (row.dic_chrg_item_type_id != 1 && !row.is_drug_type)
                        }
                    }
                },
                {
                    type: `select`,
                    prop: `enum_pay_type`,
                    label: `收费类别`,
                    width: `90`,
                    isListable: true,
                    sortable: true,
                    options: this.sys_enums.Enum_PayType,
                    readonly: (that, { row }) => {
                        if (row.is_deducted_inventory == 1) {
                            return true
                        } else {
                            return row.enum_charge_status && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2))
                        }
                    },
                    change: (that, { row }) => {
                        row.class_name = me.getRowClassName(row)
                    },
                    config: {
                        clearable: false
                    }
                },
                {
                    type: `remoteselect`,
                    prop: `modifier`,
                    label: `收费人`,
                    width: `75`,
                    isListable: true,
                    sortable: true,
                    options: (that, { row }) => {
                        return q => {
                            return this.loadWorker(q, row)
                        }
                    },
                    readonly: function(that, { row, area }) {
                        if (row.is_deducted_inventory == 1) {
                            return true
                        } else {
                            return row.id && row.id > 0 && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2))
                        }
                    }
                },
                {
                    // type: `select`,
                    type: `remoteselect`,
                    prop: `doctor`,
                    label: `开单人`,
                    width: `80`,
                    sortable: true,
                    options: (that, { row }) => {
                        return q => {
                            let doctor = JSON.parse(JSON.stringify(this.worker[`医生`]))
                            let nurse = JSON.parse(JSON.stringify(this.worker[`护士`]))
                            let works = doctor.concat(nurse) || []
                            works.map(d => {
                                d.code = d.card_no + `/` + d.section_name
                            })
                            console.log(`w`)
                            console.log(works)
                            // let works = this.worker[`医生`] || []
                            if (q && q.keyword) {
                                return works.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return works
                            }
                        }
                    },
                    change: (that, { row }) => {
                        if ((this.autoInputDoctor != `0`) && row.doctor && row.doctor.label && row.doctor.value) {
                            if (this.autoInputDoctor == `2`) {
                                this.datalist.forEach(x => {
                                    if (x.chrg_item && x.enum_charge_status == 0) {
                                        x.doctor = row.doctor
                                    }
                                })
                            } else {
                                this.datalist.forEach(x => {
                                    // 通过提取模板添加进来的和手动选择项目新增的 只要没有点击保存，都通过下面这个字段判定为 未保存
                                    if (x.chrg_item && x.pay_type == null && x.pay_type == undefined) {
                                        x.doctor = row.doctor
                                    }
                                })
                            }
                        } else {
                            if (row.doctor && row.doctor.label && row.doctor.value) {
                                this.datalist.forEach(x => {
                                    if (x.chrg_item && (!x.doctor || x.doctor == `0` || !x.doctor.value || x.doctor.value == `0`)) {
                                        x.doctor = row.doctor
                                    }
                                })
                            }
                        }
                    },
                    isListable: true,
                    readonly: (that, { row }) => {
                        if (row.is_deducted_inventory == 1) {
                            return true
                        } else {
                            return row.enum_charge_status && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2))
                        }
                    }
                },
                {
                    type: `remoteselect`,
                    prop: `billing_dept`,
                    label: `开单科室`,
                    width: `150`,
                    isListable: true,
                    sortable: true,
                    options: (that, { row }) => {
                        return q => {
                            let section = this.sectionFidlerHospitalWard
                            if (q && q.keyword) {
                                return section.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return section
                            }
                        }
                    },
                    change: (that, { row }) => {
                        if ((this.autoInputBillDept != `0`) && row.billing_dept && row.billing_dept.label && row.billing_dept.value) {
                            if (this.autoInputBillDept == `2`) {
                                this.datalist.forEach(x => {
                                    if (x.enum_charge_status == 0) {
                                        x.billing_dept = row.billing_dept
                                    }
                                })
                            } else {
                                this.datalist.forEach(x => {
                                    // 通过提取模板添加进来的和手动选择项目新增的 只要没有点击保存，都通过下面这个字段判定为 未保存
                                    if (x.pay_type == null && x.pay_type == undefined) {
                                        x.billing_dept = row.billing_dept
                                    }
                                })
                            }
                        }
                    },
                    readonly: (that, { row }) => {
                        if (row.is_deducted_inventory == 1) {
                            return true
                        } else { return row.enum_charge_status && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2)) }
                    }
                },
                {
                    type: `remoteselect`,
                    prop: `execute_dept`,
                    label: `执行科室`,
                    width: `150`,
                    isListable: true,
                    sortable: true,
                    options: (that, { row }) => {
                        return q => {
                            let section = this.sectionFidlerHospitalWard
                            if (q && q.keyword) {
                                return section.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return section
                            }
                        }
                    },
                    readonly: (that, { row }) => {
                        if (row.is_deducted_inventory == 1) {
                            return true
                        } else {
                            return row.enum_charge_status && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2))
                        }
                    }
                }, {
                    type: `datetime`,
                    prop: `billing_time`,
                    label: `收费时间`,
                    width: `180`,
                    default: this.$moment().format(`YYYY/MM/DD HH:mm`),
                    readonly: false,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `bool`,
                    prop: `is_special_medication`,
                    label: `限制性用药`,
                    width: `100`,
                    isListable: true,
                    options: `enum_bool`,
                    readonly: (that, { row }) => {
                        if (row.is_deducted_inventory == 1) {
                            return true
                        } else {
                            return row.enum_charge_status && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2))
                        }
                    },
                    default: false
                },
                {
                    type: `string`,
                    prop: `special_medication_remark`,
                    label: `限制性用药备注`,
                    isListable: true,
                    tooltip: true,
                    readonly: (that, { row }) => {
                        if (row.is_deducted_inventory == 1) {
                            return true
                        } else {
                            return row.enum_charge_status && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2))
                        }
                    },
                    width: `150`
                },
                {
                    type: `string`,
                    prop: `remark`,
                    label: `发送备注`,
                    readonly: true,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `remark_msg`,
                    readonly: (that, { row }) => {
                        if (row.is_deducted_inventory == 1) {
                            return true
                        } else {
                            return row.enum_charge_status && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2))
                        }
                    },
                    label: `备注`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `uni_charge_code`,
                    label: `统一收费编码`,
                    width: `100`,
                    readonly: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `his_code`,
                    label: `His编码`,
                    readonly: true,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `number`,
                    prop: `display_order`,
                    label: `排序`,
                    width: `80`,
                    isListable: true,
                    readonly: (that, { row }) => {
                        if (row.is_deducted_inventory == 1) {
                            return true
                        } else {
                            return row.enum_charge_status && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2))
                        }
                    }
                }, {
                    type: `string`,
                    prop: `creator`,
                    label: `创建人`,
                    width: `180`,
                    readonly: true,
                    isListable: true
                }, {
                    type: `datetime`,
                    prop: `create_date`,
                    label: `创建时间`,
                    width: `180`,
                    readonly: true,
                    isListable: true
                }, {
                    type: `datetime`,
                    prop: `modify_date`,
                    label: `修改时间`,
                    width: `180`,
                    readonly: true,
                    isListable: true
                }, {
                    type: `datetime`,
                    prop: `submit_date`,
                    label: `发送时间`,
                    width: `180`,
                    readonly: true,
                    sortable: true,
                    isListable: true
                }, {
                    type: `string`,
                    prop: `consumables_batch`,
                    label: `高值耗材编号`,
                    width: `140`,
                    readonly: function(that, { row, area }) {
                        if (row.is_deducted_inventory == 1) {
                            return true
                        } else {
                            return me.chargeScanConfig || (!me.chargeScanConfig && row.enum_charge_status && row.enum_charge_status != 0 && (!editfailed || (editfailed && row.enum_charge_status != 2)))
                        }
                    },
                    isListable: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `140`,
                    isListable: true,
                    fixed: `right`,
                    readonly: false,
                    options: (that, { row }) => {
                        if (row.is_deducted_inventory == 1) {
                            return []
                        } else {
                            let delfailed = (me.permissions && me.permissions.findIndex(item => item.permission === `charge:delete_failed_item_mzjf`) !== -1)
                            if (row.enum_charge_status == 0 || (row.enum_charge_status == 2 && delfailed)) {
                                return [
                                    {
                                        class: `is-plain`,
                                        label: `删除`,
                                        icon: ``,
                                        type: `danger`,
                                        emit: `removeItem`,
                                        permission: `default`
                                    }
                                ]
                            }
                        }
                    }
                }
            ]
        },
        tableheaderStyle() {
            const isHisBlue = this.isHisBlueThemeActive(this.themeVersion)
            let headerStyle = this.chargeListStyleObj && this.chargeListStyleObj.headerStyle
            if (isHisBlue) {
                return Object.assign({}, headerStyle || {}, {
                    color: `var(--table-header-text, #233A59)`,
                    background: `var(--table-header-bg, #E2E9F2)`,
                    height: `34px`,
                    padding: `0px 0px !important`
                })
            }
            return headerStyle || {
                color: `#fff`,
                background: this.$themePrimary,
                height: `34px`,
                padding: `0px 0px !important`
            }
        },
        regionTypeOption() {
            let r = []
            if (this.onlySimpleWard != `1`) {
                r.push({ label: `个人`, value: 1 })
            }
            r.push({ label: `区域`, value: 2 })
            return r
        },
        saveAsColumnList() {
            let me = this
            let cols = [
                {
                    type: `string`,
                    prop: `name`,
                    label: `名称`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    rowspan: 1,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `radio`,
                    prop: `region_type`,
                    label: `可用范围`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    rowspan: 1,
                    options: this.regionTypeOption,
                    default: 2,
                    change: (that, { row }) => {
                        if (row.region_type == 2) {
                            if (!row.dic_ward_ids) {
                                var ids = []
                                if (me.surgeryInfo && me.surgeryInfo.source_hospital_ward_id > 0) {
                                    ids.push(this.wardOptions && this.wardOptions.length > 0 && this.wardOptions[0].value)
                                } else {
                                    ids.push(this.active_ward.value)
                                }

                                row.dic_ward_ids = ids
                            }
                        }
                    }
                }
            ]
            let regionTypeColIndex = this.charge_template_group.length > 0 ? 2 : 1
            if (this.charge_template_group.length > 0) {
                cols.splice(1, 0,
                    {
                        type: `select`,
                        prop: `group_id`,
                        label: `分组`,
                        isListable: true,
                        isExpand: false,
                        isEditable: true,
                        isCreatable: true,
                        searchable: true,
                        rowspan: 1,
                        options: this.charge_template_group
                    })
            }
            let editpermission = _.find(this.permissions, x => x.permission == `tmp:area_edit`)
            let readpermission = _.find(this.permissions, x => x.permission == `tmp:area_read`)
            let allpermission = _.find(this.permissions, x => x.permission == `tmp:alltmp`)
            if ((readpermission && editpermission) || allpermission) {
                cols[regionTypeColIndex].options = this.regionTypeOption
                cols.push({
                    type: `groupmultiselect`,
                    prop: `dic_ward_ids`,
                    label: `可用区域`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    rowspan: 1,
                    options: this.wardOptions,
                    readonly: function(that, { row, column, area }) {
                        if (area == `form`) {
                            return row.region_type === 1
                        } else {
                            return true
                        }
                    }
                })
            } else {
                cols[regionTypeColIndex].options = _.filter(this.regionTypeOption, x => x.label == `个人` || x.value == 1)
            }
            return cols
        },
        returnChargesColumns() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `checkbox`,
                    prop: `checked`,
                    width: `40`,
                    isListable: true,
                    readonly: false
                },
                {
                    type: `string`,
                    prop: `dic_chrg_item_name`,
                    label: `项目名称`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `spec`,
                    label: `规格`,
                    width: `180`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `firm`,
                    label: `厂家`,
                    width: `180`,
                    isListable: true
                },
                {
                    type: `float`,
                    prop: `amount`,
                    label: `计费数量`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `sell_unit`,
                    label: `计价单位`,
                    width: `60`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `price`,
                    label: `单价（元）`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `total_price`,
                    label: `计费金额`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_chrg_item_type_name`,
                    label: `项目类别`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `execute_dept`,
                    label: `执行科室`,
                    width: `100`,
                    options: this.sectionFidlerHospitalWard,
                    isListable: true
                }
            ]
        },
        drugSections() {
            let all = this.sectionFidlerHospitalWard
            if (all && all.length > 0) {
                var yaofang = []
                let other = []
                for (let item of all) {
                    if (!item.disabled) {
                        if (item.label.indexOf(`药房`) >= 0) {
                            yaofang.push(item)
                        } else {
                            other.push(item)
                        }
                    }
                }
                return yaofang.concat(other)
            }
            return []
        },
        surgeryTotal() {
            let t1 = this.surgeryInfo && this.surgeryInfo.operation_begin && this.$moment(this.surgeryInfo.operation_begin)
            let t2 = this.surgeryInfo && this.surgeryInfo.operation_end && this.$moment(this.surgeryInfo.operation_end)
            if (this.$route.query.charge_type == 102) {
                t1 = this.surgeryInfo && this.surgeryInfo.in_recovery && this.$moment(this.surgeryInfo.in_recovery)
                t2 = this.surgeryInfo && this.surgeryInfo.out_recovery && this.$moment(this.surgeryInfo.out_recovery)
            }
            if (t1 && t2) {
                let ms = t2.diff(t1, `seconds`, true)
                // if(ms<60){
                //   return `${ms} s`
                // }else if(ms<3600){
                //   return `${Math.floor(ms/60)} min ${Math.floor(ms%60)} s`
                // }else{
                //   return `${Math.floor(ms/3600)} h ${Math.floor(ms%3600/60)} min`
                // }
                return `${Math.floor(ms / 3600)} h ${Math.floor((ms % 3600) / 60)} min`
            }
            return `--`
        },
        anesTotal() {
            let t1 = this.surgeryInfo && this.surgeryInfo.anesthesia_begin && this.$moment(this.surgeryInfo.anesthesia_begin)
            let t2 = this.surgeryInfo && this.surgeryInfo.anesthesia_end && this.$moment(this.surgeryInfo.anesthesia_end)
            if (this.$route.query.charge_type == 202) {
                t1 = this.surgeryInfo && this.surgeryInfo.in_recovery && this.$moment(this.surgeryInfo.in_recovery)
                t2 = this.surgeryInfo && this.surgeryInfo.out_recovery && this.$moment(this.surgeryInfo.out_recovery)
            }
            if (t1 && t2) {
                let ms = t2.diff(t1, `seconds`, true)
                // if(ms<60){
                //   return `${ms} s`
                // }else if(ms<3600){
                //   return `${Math.floor(ms/60)} min ${ms%60} s`
                // }else{
                //   return `${Math.floor(ms/3600)} h ${Math.floor(ms%3600/60)} min`
                // }
                return `${Math.floor(ms / 3600)} h ${Math.floor((ms % 3600) / 60)} min`
            }
            return `--`
        },
        totalPrice() {
            let totalprice = ``
            if (this.datalist.length > 0) {
                let sum = _.sumBy(
                    _.filter(this.datalist, d => {
                        return d.enum_fee_type == 1 // return d.enum_charge_status == 1
                    }),
                    d => d.enum_fee_type * d.total_price
                )
                totalprice = sum.toNewFixed(this.charge_Total_Decimaldigits)
            } else {
                totalprice = `--`
            }
            return totalprice
        },
        count() {
            let result = 8
            if (this.mzjfclassification == `1`) {
                result = 4
            }
            return result
        },
        drugsPrice() {
            return (
                (this.datalist.length > 0 &&
                    _.sumBy(
                        _.filter(this.datalist, d => {
                            return d.enum_fee_type == 1 && (d.dic_chrg_item_type_id == 1 || d.is_drug_type)
                        }),
                        d => d.enum_fee_type * d.total_price
                    ).toNewFixed(this.charge_Total_Decimaldigits)) ||
                `--`
            )
        },
        otherPrice() {
            return (
                (this.datalist.length > 0 &&
                    _.sumBy(
                        _.filter(this.datalist, d => {
                            return d.enum_fee_type == 1 && d.dic_chrg_item_type_id != 1 && !d.is_drug_type
                        }),
                        d => d.enum_fee_type * d.total_price
                    ).toNewFixed(this.charge_Total_Decimaldigits)) ||
                `--`
            )
        },
        totalCount() {
            let num = 0
            if (this.datalist.length > 0) {
                this.datalist.forEach(x => {
                    if (x.enum_fee_type == 1) {
                        num++
                    }
                })
            }
            return num
        },
        tfPrice() {
            let sum = 0
            if (this.datalist.length > 0) {
                this.datalist.forEach(x => {
                    if (x.total_price && x.total_price > 0 && x.enum_fee_type != 1) {
                        sum += parseFloat(x.total_price)
                    }
                })
            }
            return sum.toNewFixed(this.charge_Total_Decimaldigits)
        },
        charge_item_options() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/ChargeItem/SearchType`)
                req.then(data => {
                    data = _.map(data, d => {
                        return {}
                    })
                    resolve(data)
                })
            })
        },
        userListColumn() {
            let that = this
            if (this.configColumns.length == 0) {
                return this.columnList
            } else if (this.user_config_columns.length == 0) {
                // added by xiaorui,默认如果用户没有配置任何列 则 1.列配置勾选上当前页面所有列 2.展示当前列表上所有列
                that.user_config_columns = that.configColumns.map(c => c.value)
                return this.columnList
            }
            let allcolumn = _.filter(this.columnList, c => {
                return _.includes(this.user_config_columns, c.prop) || c.isExpand || c.isKey || (c.isDisplayOrder && c.isListable)
            })
            // debugger
            allcolumn.map(d => {
                // debugger
                let f = that.user_config_columns2.find(s => s.col_name == d.prop)
                if (f && f.col_width > 0) {
                    d.width = f.col_width
                }
            })
            let r = _.orderBy(allcolumn, function(ac) {
                let i = _.findIndex(that.configColumns, { value: ac.prop })
                return i
            })
            return r
        },
        titleLabel() {
            return function() {
                let totalDrugFee = `--`
                let totalNoDrugFee = `--`
                if (this.datalist.length > 0) {
                    totalDrugFee = _.sumBy(
                        _.filter(this.datalist, d => {
                            return d.enum_fee_type == 1 && (d.dic_chrg_item_type_id == 1 || d.is_drug_type)
                        }),
                        d => d.enum_fee_type * d.total_price
                    ).toNewFixed(this.charge_Total_Decimaldigits)
                }
                totalNoDrugFee = _.sumBy(
                    _.filter(this.datalist, d => {
                        return d.enum_fee_type == 1 && d.dic_chrg_item_type_id != 1 && !d.is_drug_type
                    }),
                    d => d.enum_fee_type * d.total_price
                ).toNewFixed(this.charge_Total_Decimaldigits)

                let title = `药品费:${totalDrugFee}
非药品费:${totalNoDrugFee}`
                return title
            }
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
        this.$store.dispatch(`ADD_RECOVERY_WARD`)
        this.$store.dispatch(`drug/ADD_DRUG_WAY`)
    },
    mounted() {
        this.setupThemeObserver()
        this.loadPermissions()
        this.loadConfigs().then(() => {
            this.loadChargeItemTypes().then(() => {
                this.loadTransportNodes()
                this.loadSurgery().then(() => {
                    this.loadChargeItems()
                    this.loadDocumentList().then(data => {
                        this.loadBasePdfUrl()
                    })
                })
            })
        })
        //  加载所有枚举
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.$store.dispatch(`enums/ADD_ALL_ENUM`)
        this.$store.dispatch(`ADD_WARD_AUTH`)
        // this.$store.dispatch("drug/ADD_DRUG_TYPE")
        this.$store.dispatch(`ADD_SECTION_AUTH`)

        // 加载配置列
        this.LoadUserColumns()
        this.configColumnDrop()
        if (this.chargeStatusBgColor != ``) {
            let t = eval(
                `(` + this.chargeStatusBgColor + `)`
            )
            this.chargeStatusBgColorObj = t
        }
        // 备注栏信息配置
        this.getRemarksColumn()
    },
    beforeDestroy() {
        if (this.themeObserver) {
            this.themeObserver.disconnect()
            this.themeObserver = null
        }
    },
    inject: [`reload`],
    methods: {
        isHisBlueThemeActive(themeVersion) {
            let currentTheme = localStorage.getItem(`app_theme`) || ``
            let bodyHasBlue = document.body && document.body.classList && document.body.classList.contains(`theme-his-blue`)
            return currentTheme === `theme-his-blue` || bodyHasBlue
        },
        setupThemeObserver() {
            if (typeof MutationObserver === `undefined` || !document.body) return
            if (this.themeObserver) {
                this.themeObserver.disconnect()
                this.themeObserver = null
            }
            this.themeObserver = new MutationObserver(() => {
                this.themeVersion += 1
            })
            this.themeObserver.observe(document.body, { attributes: true, attributeFilter: [`class`] })
        },
        isGreenToneColor(colorValue) {
            if (!colorValue || typeof colorValue !== `string`) return false
            const color = colorValue.replace(/\s+/g, ``).toLowerCase()
            if (/^#0{0,2}9688/.test(color)) return true
            if (/^#33aba0/.test(color)) return true
            if (/^#26a69a/.test(color)) return true
            if (color.includes(`rgb(0,150,136)`)) return true
            if (color.includes(`rgba(0,150,136`)) return true
            if (color.includes(`rgb(51,171,160)`)) return true
            if (color.includes(`rgba(51,171,160`)) return true
            if (color.includes(`green`) || color.includes(`teal`)) return true
            return false
        },
        loadTransportNodes() {
            var that = this
            if (that.surgeryId && that.surgeryId > 0) {
                let req = this.myaxios.get(`/api/Nursing/PatientTransport/GetProcSurgeryTransport/${that.surgeryId}`)
                req.then(data => {
                    if (data && data.length > 0) {
                        that.hasNodes = true
                    }
                }).catch(e => {
                    console.log(e)
                })
            }
        },
        // 事件方法
        getReload() {
            this.reload() // 重置刷新
        },
        getRemarksColumn() {
            var that = this
            if (that.surgeryId && that.surgeryId > 0) {
                let req = this.myaxios.get(`/api/Nursing/Charge/GetRemarksColumn?surgeryId=${that.surgeryId}&chargeType=${that.chargeType}`)
                req.then(data => {
                    if (data) {
                        console.log(data)
                        that.showRemarksColumnConfig = true
                        that.remarksColumn = data
                    } else {
                        that.showRemarksColumnConfig = false
                    }
                }).catch(e => {
                    console.log(e)
                    that.showRemarksColumnConfig = false
                })
            } else {
                that.showRemarksColumnConfig = false
            }
        },
        getRowClassName(row) {
            let that = this
            let className = ` charge-row`

            if (row.enum_pay_type == null) {
                className += ` fontpayTypeNull`
            } else if (row.amount == 0) {
                className += ` fontamountZero`
            } else if (row.chrg_item_type_abbr && that.chrgItemTypesColorObj) {
                className += ` font${row.chrg_item_type_abbr}`
            } else if (row.font_color && row.font_color != ``) {
                className += ` font${row.font_color}`
            }
            // 数量样式
            if (this.amountOverColorInfo && row.chrg_item_type_abbr && this.amountOverColorInfo[`${row.chrg_item_type_abbr}`]) {
                let amount = this.amountOverColorInfo[`${row.chrg_item_type_abbr}`].amount
                if (amount && row.amount >= amount && this.amountOverColorInfo[`${row.chrg_item_type_abbr}`].color) {
                    className += ` font${row.chrg_item_type_abbr}AmounOver`
                }
            } else if (row.amount >= that.amountOverNum) {
                className += ` fontamounOver`
            }
            return className
        },
        loadDocument(recordType) {
            // 多屏直接在其他屏幕打开
            if (isMultiScreen(this.setMultiScreen)) {
                var that = this
                let req = this.myaxios.get(`/api/Operation/Home/GetPdfUrl?surgeryInfoId=${this.surgeryInfo.id}&recordType=${recordType}`)
                req.then(data => {
                    if (data) {
                        that.basepdf = data
                        let r = typeof winformMsg
                        if (r != `undefined`) {
                            var cefJson = {
                                action: `openPdfView`,
                                pdfUrl: this.basepdf
                            }
                            winformMsg.acceptMessage(cefJson)
                        } else { openNewWindow(this.basepdf, `文档`, this.setMultiScreen) }
                    } else { this.$message.error(`未能获取文档地址`) }
                }).catch(e => console.log(e))
            } else {
                if (this.surgeryInfo && this.surgeryInfo.id) {
                    let req = this.myaxios.post(`/api/Operation/Home/ExportPdf?surgeryInfoId=${this.surgeryInfo.id}&recordType=${recordType}`)
                    req.then(data => {
                        let title = `麻醉记录单`
                        if (recordType == 2) {
                            title = `复苏记录单`
                        } else if (recordType == 0) {
                            title = `合并记录单`
                        }
                        this.pdfvisible = true
                        this.base64 = data
                        this.typeTitle = title
                    }).catch(e => console.log(e))
                }
            }
        },
        loadBasePdfUrl() {
            var that = this
            // 多屏直接在其他屏幕打开
            if (that.loadDocumentListButton.length > 0) {
                if (isMultiScreen(this.setMultiScreen)) {
                    if (this.surgeryInfo && this.surgeryInfo.id) {
                        var recordType = 0
                        that.loadDocument(recordType)
                    }
                }
            }
        },
        loadDocumentList() {
            var that = this
            that.loadDocumentListButton = []
            return new Promise((resolve, reject) => {
                if (this.surgeryInfo && this.surgeryInfo.id) {
                    let req = this.myaxios.get(`/api/Operation/Home/ArchiveList?surgeryInfoId=${this.surgeryInfo.id}`)
                    req.then(data => {
                        that.loadDocumentListButton = _.map(data, d => {
                            return {
                                enum_record_type: d.enum_record_type,
                                record_type: d.record_type
                            }
                        })
                        resolve(that.loadDocumentListButton)
                    }).catch(e => reject(e))
                }
            })
        },
        print(command) {
            let that = this
            if (command == `printChargeItems`) {
                that.printChargeItems()
            }
            if (command == `printChargeAllItems`) {
                that.printChargeAllItems()
            }
        },
        mzjfPrint() {
            return this.mzjfPrintBtnName != `0` && this.mzjfPrintAllBtnName != `0`
        },
        changeExpeditedBtnName() {
            this.$confirm(`是否确定${this.expeditedStatus ? `取消加急收费` : `加急收费`}?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.put(`/api/Nursing/Charge/ChangeExpeditedStatus?surgeryId=${this.surgeryId}&chargeType=${this.chargeType}&expeditedStatus=${!this.expeditedStatus}`)
                req.then(data => {
                    this.loadSurgerybody()
                }).catch(e => {
                    console.log(e)
                })
            }).catch(e => { })
        },
        changeApprovalBtnName() {
            let approvalStatus = this.approvalStatus ? 0 : 1
            let data = _.filter(this.datalist, d => d.enum_charge_status)
            if (data && data.length == 0) {
                this.$alert(`没有审核项目`, `提醒`, {
                    dangerouslyUseHTMLString: true,
                    type: `warning`
                })
                return
            }
            if (approvalStatus == 1) {
                // 看看有没有计费成功和退费成功以外其它状态，有 审核时弹框提示，不能审核
                let allchargenosucess = data &&
                        _.filter(data, d => { return ((d.enum_charge_status !== 1) && (d.enum_charge_status !== 3) && (d.enum_fee_type == 1)) })
                if (allchargenosucess.length > 0) {
                    this.$alert(`所有项目都计费成功和退费成功才能审核`, `提醒`, {
                        dangerouslyUseHTMLString: true,
                        type: `warning`
                    })

                    return
                }

                this.$confirm(`请仔细核对每一条计费成功的项目,审核后页面将会被冻结?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`,
                    closeOnClickModal: false
                }).then(() => {
                    let url = this.getQueryUrl()
                    let req = this.myaxios.put(`/api/Nursing/Charge/ChangeApprovalStatus?surgeryId=${this.surgeryId}&chargeType=${this.chargeType}&approvalStatus=${approvalStatus}${url}`)
                    req.then(data => {
                        this.loadChargeItems()
                    }).catch(e => {
                        console.log(e)
                    })
                }).catch(e => { })
            } else {
                let url = this.getQueryUrl()
                let req = this.myaxios.put(`/api/Nursing/Charge/ChangeApprovalStatus?surgeryId=${this.surgeryId}&chargeType=${this.chargeType}&approvalStatus=${approvalStatus}${url}`)
                req.then(data => {
                    this.loadChargeItems()
                }).catch(e => {
                    console.log(e)
                })
            }
        },
        loadPermissions() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(data => {
                this.permissions = data
            }).catch(e => {})
        },
        setRowValue(row, data, payType) {
            let that = this
            this.$set(row, `enum_pay_type`, payType)
            if (row.enum_fee_type == undefined && this.chargeItemAddConfig == `1`) {
                this.datalist.push({ ___index: _.now(), active: true, class_name: ` charge-row` })
            }
            this.$set(row, `font_color`, data.font_color)
            this.$set(row, `chrg_item_type_abbr`, data.chrg_item_type_abbr)

            row.class_name = that.getRowClassName(row)
            this.$set(row, `enum_fee_type`, 1)
            // this.$set(row,"display_order",index+1)
            this.$set(row, `limit_price_type`, data.limit_price_type)
            this.$set(row, `min_price`, data.min_price)
            this.$set(row, `max_price`, data.max_price)
            this.$set(row, `spec`, data.spec)
            this.$set(row, `firm`, data.firm)
            this.$set(row, `sell_unit`, data.sell_unit)
            this.$set(row, `remark_msg`, data.remark_msg)
            this.$set(row, `price`, data.price)
            this.$set(row, `dic_chrg_item_type_id`, data.dic_chrg_item_type_id)
            this.$set(row, `is_drug_type`, data.is_drug_type)
            this.$set(row, `amount`, 1.0)
            this.$set(row, `enum_charge_status`, 0)
            this.$set(row, `total_price`, (data.price * 1.0).toNewFixed(this.charge_Total_Decimaldigits))
            this.$set(row, `dic_add_drug_way_id`, data.dic_add_drug_way_id)

            if (row.dic_chrg_item_type_name == `不计费`) {
                this.$set(row, `enum_fee_type`, 2) // 默认不计费
                this.$set(row, `total_price`, 0)
            }
            this.$set(row, `modifier`, this.currentUser && this.currentUser.dic_worker_name)
            if (this.datalist.length <= 2) {
                this.setDefaultValue(row)
            } else {
                let predata = this.getPreData(row)
                if (predata) {
                    this.setPredataDefault(row, predata)
                } else {
                    this.setDefaultValue(row)
                    if (!row.doctor || !row.billing_dept || !row.execute_dept) {
                    // ACIS-24801 ,手动输入的项目,如果找不到上一个相同类型的计费项时，直接取上一条数据的开单科室，执行科室等
                        let currSeqNo = parseInt(row.___sequence_no)
                        let PreviousNo = `${currSeqNo - 1}`
                        let predata = this.$refs[`supplies-list`].datalist.find(i => i.___sequence_no == PreviousNo)
                        if (predata) {
                            this.setPredataDefault(row, predata)
                        }
                    }
                }
            }

            this.$set(row, `uni_charge_code`, data.uni_charge_code)
        },
        setDefaultValue(d) {
            if (!d.enum_pay_type) {
                d.enum_pay_type = this.default_pay_type
            }
            if (!d.doctor || d.doctor == `0`) {
                if (this.default_doctor && this.default_doctor.value) {
                    this.$set(d, `doctor`, this.default_doctor)
                } else {
                    this.$set(d, `doctor`, null)
                }
            } else {
                if (_.has(d.doctor, `value`) || _.has(d.doctor, `label`)) {
                    if (!d.doctor.value || !d.doctor.label) {
                        this.$set(d, `doctor`, null)
                    }
                } else {
                    if (d.doctorName && d.doctor) {
                        this.$set(d, `doctor`, {
                            label: d.doctorName,
                            value: parseInt(d.doctor)
                        })
                    } else {
                        this.$set(d, `doctor`, null)
                    }
                }
            }
            if (!d.billing_dept || d.billing_dept == `0`) {
                // this.$set(d, `billing_dept`, this.default_anes_section_id) // 麻醉计费默认科室
                this.$set(d, `billing_dept`, this.default_anes_section) // 麻醉计费默认科室
            }
            if (!d.execute_dept || d.execute_dept == `0`) {
                if (d.dic_chrg_item_type_id == 1 || d.is_drug_type) {
                    // this.$set(d, `execute_dept`, this.default_drug_section_id)// 默认药房
                    this.$set(d, `execute_dept`, this.default_drug_section) // 默认药房
                } else {
                    // this.$set(d, `execute_dept`, this.default_anes_section_id)// 麻醉计费默认科室
                    this.$set(d, `execute_dept`, this.default_anes_section) // 麻醉计费默认科室
                }
            }
        },
        getSectionNameById(id) {
            if (!id) return ``
            let item = _.find(this.sectionFidlerHospitalWard, x => x.value == parseInt(id))
            if (item) { return item.label || `` }
            return ``
        },
        getSectionById(id) {
            if (!id) return
            let item = _.find(this.sectionFidlerHospitalWard, x => x.value == parseInt(id))
            return item
        },
        selectionChange({ row }) {
            this.checkedRow = row
        },
        ExtraButtonClick(target) {
            if (this[target.emit]) {
                this[target.emit](target)
            } else {
                this.$emit(target.emit, target)
            }
        },
        handleNodeClick(node, self, child) {
            let that = this
            if (!_.has(node, `children`)) {
                // 加载已选模板详情
                if (!node.value) return
                // url 过滤 模板加载计费项类型
                let url = this.getQueryUrl()
                let req = that.myaxios.get(`/api/AcisSystem/ChargeTemplate/Get?id=${node.value}${url}`)
                req.then(template => {
                    let r = _.map(template.items, d => {
                        d.enum_fee_type = 1
                        d.enum_charge_status = 0
                        d.total_price = 1.0 * d.charge_item.price
                        d.spec = d.charge_item.spec
                        d.firm = d.charge_item.firm
                        d.sell_unit = d.charge_item.sell_unit
                        d.price = d.charge_item.price
                        d.dic_chrg_item_type_id = d.dic_chrg_item_type_id
                        d.is_drug_type = d.charge_item.is_drug_type
                        d.dic_chrg_item_type_name = this.getChargeItemTypeName(d.dic_chrg_item_type_id)
                        d.dic_chrg_item_name = d.charge_item.name
                        d.chrg_item = {
                            label: d.charge_item.name,
                            value: d.charge_item.id
                        }
                        d.dic_section_id = d.dic_section_id
                        if (d.dic_section_id && d.dic_section_id > 0) {
                            d.execute_dept = this.getSectionById(d.dic_section_id)
                        }
                        return d
                    })
                    that.collectCharges.datalist = _.orderBy(r, `display_order`)
                    this.$nextTick(function() {
                        if (this.charge_template_selected && this.charge_template_selected === `1`) {
                            this.$refs.collectChargeslist.selectAll(true)
                        }
                    })
                })
            }
        },
        loadSurgery() {
            return new Promise((resolve, reject) => {
                if (!this.surgeryId) {
                    resolve()
                    return
                }
                if (this.surgeryInfo && this.surgeryInfo.id == this.surgeryId) {
                    resolve(this.surgeryInfo)
                } else {
                    resolve(this.loadSurgerybody())
                }
            })
        },
        loadSurgerybody() {
            return new Promise((resolve, reject) => {
                let req1 = this.myaxios.get(`/api/Preoperative/Apply/Get/${this.surgeryId}`)
                req1.then(data => {
                    this.surgeryInfo = data
                    this.expeditedStatus = data.is_expedited
                    this.default_pay_type = this.surgeryInfo.visit_info && this.surgeryInfo.visit_info.enum_pay_type
                    if (this.configdefaultPayType != `0`) {
                        this.default_pay_type = this.configdefaultPayType
                    }
                    this.default_anes_section_id = this.surgeryInfo.anes_section_id
                    if (this.surgeryInfo.anes_section_id && this.surgeryInfo.anes_section_id > 0) {
                        this.default_anes_section = this.getSectionById(this.surgeryInfo.anes_section_id)
                    }

                    this.default_drug_section_id = this.surgeryInfo.drug_section_id
                    if (this.surgeryInfo.drug_section_id && this.surgeryInfo.drug_section_id > 0) {
                        this.default_drug_section = this.getSectionById(this.surgeryInfo.drug_section_id)
                    }

                    this.default_section_id = this.surgeryInfo.dic_section_id
                    if (this.surgeryInfo.dic_section_id && this.surgeryInfo.dic_section_id > 0) {
                        this.default_section = this.getSectionById(this.surgeryInfo.dic_section_id)
                    }

                    if (this.surgeryInfo.fact_anes_doctor && this.surgeryInfo.fact_anes_doctor.value) {
                        this.default_doctor = {
                            label: this.surgeryInfo.fact_anes_doctor.label,
                            value: this.surgeryInfo.fact_anes_doctor.value
                        }
                    } else if (this.surgeryInfo.plan_anes_doctor && this.surgeryInfo.plan_anes_doctor.value) {
                        this.default_doctor = {
                            label: this.surgeryInfo.plan_anes_doctor.label,
                            value: this.surgeryInfo.plan_anes_doctor.value
                        }
                    }

                    resolve(this.surgeryInfo)
                }).catch(e => {
                    console.log(e)
                    resolve({})
                })
            })
        },
        getPreData(row) {
            var alldata = this.datalist
            if (alldata.length <= 2) return undefined
            if (this.defaultPrevRow == `0`) {
                for (var i = alldata.length - 3; i >= 0; i--) {
                    let cur = alldata[i]
                    if (cur.dic_chrg_item_type_id == row.dic_chrg_item_type_id) {
                        return cur
                    }
                }
            } else {
                // ACIS-24801 ,手动输入的项目,如果找不到上一个相同类型的计费项时，直接取上一条数据的开单科室，执行科室等
                let currSeqNo = parseInt(row.___sequence_no)
                let PreviousNo = `${currSeqNo - 1}`
                let predata = this.$refs[`supplies-list`].datalist.find(i => i.___sequence_no == PreviousNo)
                return predata
            }
            return undefined
        },
        // 获取上一行执行科室、计费科室、执行人设置给当前行对应字段
        setPredataDefault(row, predata) {
            if (!row.doctor) {
                this.$set(row, `doctor`, predata.doctor)
            }
            if (!row.billing_dept) {
                this.$set(row, `billing_dept`, predata.billing_dept)
            }
            if (!row.execute_dept || row.execute_dept == `0`) {
                if (this.defaultPrevRow != `1`) {
                    this.$set(row, `execute_dept`, predata.execute_dept)
                } else {
                    // this.$set(row, `execute_dept`, this.default_anes_section) // 麻醉计费默认科室

                    if (row.dic_chrg_item_type_id == 1 || row.is_drug_type) {
                        this.$set(row, `execute_dept`, this.default_drug_section) // 默认药房
                    } else {
                        this.$set(row, `execute_dept`, this.default_anes_section) // 麻醉计费默认科室
                    }
                }
            }

            if (!row.modifier) {
                this.$set(row, `modifier`, predata.modifier)
            }
        },
        removeItem({ row, index }) {
            let selectRows = _.filter(this.checkedRow, d => {
                return d.id > 0
            })
            let batchdel = (this.permissions && this.permissions.findIndex(item => item.permission === `charge:batchdeletemzjf`) !== -1)
            if (batchdel && selectRows && selectRows.length > 1) {
                this.$confirm(`检测到选择了多条数据，是否全部删除?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`,
                    closeOnClickModal: false
                }).then(() => {
                    let ids = _.map(selectRows, d => d.id)
                    let req = this.myaxios.post(`/api/Nursing/Charge/BatchDelete`, ids)
                    req.then(data => {
                        this.loadChargeItems()
                    }).catch(e => {
                        // this.$message.error(`删除异常,请尝试刷新后重新删除`)
                        console.log(e)
                    })
                }).catch(e => { })
            } else { // 原功能代码 仅删除按钮点击行
                this.$confirm(`是否确认删除?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `error`
                }).then(() => {
                    if (row.id > 0) {
                        let req = this.myaxios.delete(`/api/Nursing/Charge/Delete/${row.id}`)
                        req.then(data => {
                            this.datalist.splice(index, 1)
                        })
                    } else {
                        this.datalist.splice(index, 1)
                    }
                }).catch(() => {})
            }
        },
        SaveAsConfirm(row) {
            var postData = {
                surgeryId: this.surgeryId,
                chargetype: this.chargeType,
                group_id: row.group_id,
                templatename: row.name,
                regions: row.region_type == 1
                    ? [{ owner: this.currentUser.username }]
                    : row.dic_ward_ids.map(d => {
                        return {
                            sys_charge_template_id: 0,
                            dic_operating_ward_id: _.startsWith(d, `ow_`) ? d.substr(3) : 0,
                            dic_recovery_ward_id: _.startsWith(d, `rw_`) ? d.substr(3) : 0
                        }
                    })
            }
            this.myaxios.post(
                `/api/AcisSystem/ChargeTemplate/SaveAsChargeTemplate`,
                postData
            ).then(data => {
                this.$message.success(`另存为模板成功`)
                this.saveas.dialogFormVisible = false
            }).catch(e => this.$message.error(e))
        },
        refreshChargeItems() {
            this.loadChargeItems()
            this.$emit(`refreshsurgeInfos`)
        },
        loadChargeItems() {
            let that = this
            return new Promise((resolve, reject) => {
                if (!this.surgeryId) {
                    resolve()
                    return
                }
                let url = this.getQueryUrl()
                let req = this.myaxios.get(`/api/Nursing/Charge/Get?surgeryId=${this.surgeryId}&&chargeType=${this.chargeType}${url}`)
                req.then(async data => {
                    console.log(data)
                    let hasapprovaled = data && _.filter(data, d => d.approval_status == 1)
                    if (hasapprovaled.length > 0) {
                        // 有审核的，则冻结页面
                        this.approvalStatus = true
                    } else {
                        this.approvalStatus = false
                    }

                    let r =
                        (data &&
                            _.filter(data, d => {
                                return (
                                    (this.charge_item_type.length == 0 || (this.charge_item_type && this.charge_item_type == d.dic_chrg_item_type_id)) &&
                                    (d.enum_charge_status == this.status || this.status.length == 0) &&
                                    (d.enum_fee_type == this.fee_type || this.fee_type.length == 0)
                                )
                            })) ||
                        []
                    r = _.map(r, d => {
                        d.font_color = d.dic_chrg_item && d.dic_chrg_item.font_color
                        d.chrg_item_type_abbr = d.dic_chrg_item && d.dic_chrg_item.chrg_item_type_abbr

                        d.class_name = that.getRowClassName(d)
                        return d
                    })
                    let mainRows = []
                    let bjfRows = []
                    _.map(r, (d, index) => {
                        d.___index = _.now() + (index + 1) * 1000
                        d.spec = (d.dic_chrg_item && d.dic_chrg_item.spec) || ``
                        d.firm = (d.dic_chrg_item && d.dic_chrg_item.firm) || ``
                        d.sell_unit = (d.dic_chrg_item && d.dic_chrg_item.sell_unit) || ``
                        d.price = d.price || ((d.dic_chrg_item && d.dic_chrg_item.price) || ``)
                        d.dic_chrg_item_name = (d.dic_chrg_item && d.dic_chrg_item.name) || ``
                        d.dic_chrg_item_type_id = d.dic_chrg_item_type_id || 0
                        d.is_drug_type = d.dic_chrg_item && d.dic_chrg_item.is_drug_type
                        d.dic_chrg_item_type_name = this.getChargeItemTypeName(d.dic_chrg_item_type_id)
                        // Object.assign(d,d.dic_chrg_item)
                        d.chrg_item = {
                            label: (d.dic_chrg_item && d.dic_chrg_item.name) || ``,
                            value: (d.dic_chrg_item && d.dic_chrg_item.id) || 0
                        }
                        if (d.billing_dept && d.billing_dept != `0`) {
                            d.billing_dept = that.getSectionById(d.billing_dept)
                        }

                        if (d.execute_dept && d.execute_dept != `0`) {
                            d.execute_dept = that.getSectionById(d.execute_dept)
                        }
                        d.total_price = this.$multiplyMaths.multiply(parseFloat(d.price), parseFloat(d.amount)).toNewFixed(this.charge_Total_Decimaldigits)
                        d.limit_price_type = d.dic_chrg_item && d.dic_chrg_item.limit_price_type
                        d.min_price = d.dic_chrg_item && d.dic_chrg_item.min_price
                        d.max_price = d.dic_chrg_item && d.dic_chrg_item.max_price
                        d.uni_charge_code = (d.dic_chrg_item && d.dic_chrg_item.uni_charge_code) || ``
                        d.display_order = d.display_order
                        this.setDefaultValue(d)
                        // if (d.enum_fee_type == -1) {
                        //     this.$set(d, `class_name`, `fontredtip`)
                        // }
                        // d.execute_dept = d.execute_dept * 1
                        if (d.dic_chrg_item_type_name == `不计费`) {
                            bjfRows.push(d)
                        } else {
                            mainRows.push(d)
                        }
                    })

                    let olddatalist = this.datalist.concat()
                    this.datalist = mainRows.concat(bjfRows)
                    console.log(this.datalist, `this.datalist`)
                    if (this.isDrugAlert && (this.syncUseDrugIn || this.templateIn)) { // 开启特殊用药弹框提示 且 点击了同步用药或者提取模板
                        for await (const r of this.datalist) {
                        // 计费项类型是药品 且 药品Remark有值【remark有值表示特殊用药】
                            if (r.dic_chrg_item && r.dic_chrg_item.remark && (this.isDrugChargeItemShow == `1` || (this.isDrugChargeItemShow == `2` && (r.dic_chrg_item.is_special_medication || 0) == 1))) {
                                let noexist = _.find(olddatalist, function(m) {
                                    return m.id == r.id
                                })
                                if (!noexist) {
                                    this.$confirm(`医保中心提示：该项目 【${r.chrg_item.label}】 <br/><br/>${r.dic_chrg_item.remark}<br/><br/>选择【是】将设置为医保，【否】将设置为自费，【X】不开立本医嘱`, `医保中心提示`, {
                                        confirmButtonText: `是`,
                                        cancelButtonText: `否`,
                                        distinguishCancelAndClose: true,
                                        dangerouslyUseHTMLString: true,
                                        closeOnClickModal: false
                                    }).then(() => {
                                        r.enum_pay_type = 2 // 是 2=医保
                                    }).catch((action) => {
                                        if (action === `cancel`) {
                                            r.enum_pay_type = 3 // 否 3=自费
                                        } else { // 取消同步
                                            let idx = _.findIndex(this.datalist, { id: r.id })
                                            if (idx >= 0) {
                                                this.removeItem({ row: r, index: idx })
                                            }
                                        }
                                    })
                                }
                            }
                        }
                        this.syncUseDrugIn = false
                        this.templateIn = false // 弹框结束后，设置成false
                    }
                    console.log(this.datalist)
                    if (this.chargeItemAddConfig == `1`) {
                        this.datalist.push({ active: true, class_name: ` charge-row` })
                    }
                    resolve()
                }).catch(e => reject(e))
            })
        },
        getAdd() {
            let data1 = _.map(
                _.filter(this.datalist, d => d.chrg_item && d.chrg_item.value && !d.id),
                d => {
                    return {
                        id: d.id,
                        biz_surgery_info_id: this.surgeryId,
                        enum_charge_type: this.chargeType,
                        enum_fee_type: d.enum_fee_type,
                        enum_charge_status: d.enum_charge_status,
                        enum_pay_type: d.enum_pay_type,
                        dic_chrg_item_id: d.chrg_item.value,
                        dic_chrg_item_type_id: d.dic_chrg_item_type_id,
                        amount: d.amount,
                        price: d.price,
                        doctor: d.doctor && d.doctor.value,
                        modifier: _.isString(d.modifier) ? d.modifier : d.modifier.label,
                        billing_dept: d.billing_dept && d.billing_dept.value,
                        execute_dept: d.execute_dept && d.execute_dept.value,
                        display_order: d.display_order,
                        consumables_batch: d.consumables_batch,
                        remark: d.remark,
                        item_name: d.chrg_item.label,
                        // "remark": "string",
                        // "his_code": "string",
                        // "is_sync_data": false,
                        total_price: d.total_price,
                        remark_msg: d.remark_msg,
                        dic_add_drug_way_id: d.dic_add_drug_way_id,
                        is_special_medication: d.is_special_medication,
                        special_medication_remark: d.special_medication_remark,
                        billing_time: d.billing_time || this.$moment().format(`YYYY/MM/DD HH:mm`)
                    }
                }
            )
            return data1
        },
        getEdit() {
            let data2 = _.map(
                _.filter(this.datalist, d => d.chrg_item && d.chrg_item.value && d.id > 0 && (d.enum_charge_status == 0 || d.enum_charge_status == 2)),
                d => {
                    return {
                        id: d.id,
                        // biz_surgery_info_id: this.surgeryId, 解决偶发性病人数据被覆盖了问题
                        // enum_charge_type: this.chargeType,
                        enum_fee_type: d.enum_fee_type,
                        enum_charge_status: d.enum_charge_status,
                        enum_pay_type: d.enum_pay_type,
                        dic_chrg_item_id: d.chrg_item.value,
                        dic_chrg_item_type_id: d.dic_chrg_item_type_id,
                        amount: d.amount,
                        price: d.price,
                        billing_dept: d.billing_dept && d.billing_dept.value,
                        execute_dept: d.execute_dept && d.execute_dept.value,
                        display_order: d.display_order,
                        consumables_batch: d.consumables_batch,
                        doctor: d.doctor && d.doctor.value,
                        item_name: d.chrg_item.label,
                        modifier: _.isString(d.modifier) ? d.modifier : d.modifier.label,
                        total_price: d.total_price,
                        remark: d.remark,
                        remark_msg: d.remark_msg,
                        dic_add_drug_way_id: d.dic_add_drug_way_id,
                        is_special_medication: d.is_special_medication,
                        special_medication_remark: d.special_medication_remark,
                        billing_time: d.billing_time || this.$moment().format(`YYYY/MM/DD HH:mm`)
                    }
                }
            )
            return data2
        },
        getQueryUrl() {
            // url 过滤 模板加载计费项类型
            let itemtype = this.$route.query.charge_item_types || null
            let url = ``
            if (itemtype) {
                url = `&chargeItemTypes=${itemtype}`
            }
            return url
        },
        saveItems(his) {
            return new Promise((resolve, reject) => {
                try {
                    var pddata = _.filter(this.datalist, d => d.chrg_item && d.chrg_item.value && d.chrg_item.value > 0)
                    var noneAmountArr = []
                    pddata.forEach(d => {
                        if (d.dic_chrg_item_type_id == null) {
                            this.$message.error(`请选择项目类别！`)
                            throw new Error(`EndIterative`)
                        }
                        if (d.enum_pay_type == null) {
                            this.$message.error(`请选择收费类别！`)
                            throw new Error(`EndIterative`)
                        }
                        if (!d.doctor) {
                            this.$message.error(`请选择开单人！`)
                            throw new Error(`EndIterative`)
                        }

                        if (!d.billing_dept || (d.billing_dept && !d.billing_dept.value)) {
                            this.$message.error(`请选择开单科室！`)
                            throw new Error(`EndIterative`)
                        }
                        if (!d.execute_dept || (d.execute_dept && !d.execute_dept.value)) {
                            this.$message.error(`请选择执行科室！`)
                            throw new Error(`EndIterative`)
                        }

                        if (!d.amount || d.amount <= 0) {
                            noneAmountArr.push(d)
                        }
                    })
                } catch (e) {
                    if (e.message != `EndIterative`) throw e
                    return
                }
                // 计费数量输入提示
                if (noneAmountArr.length > 0) {
                    this.$confirm(`存在计费数量为空或小于等于0的数据<br/>是否确认保存?`, `提示`, {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText: `确定`,
                        cancelButtonText: `取消`,
                        type: `warning`
                    }).then(() => {
                        let data1 = this.getAdd()
                        let data2 = this.getEdit()

                        // 计费中存在相同计费项目是否提示,欢哥加的弱验证，不阻止提交
                        if (this.$root.IsChargeShowAlertHasSameItem == `1`) {
                            this.validSameItem()
                        }
                        // 计费中存在相同计费项目是否提示,肖锐加的强验证，阻止提交
                        if (this.$root.IsChargeShowAlertHasSameItem == `2`) {
                            try {
                                this.validSameItem(true)
                            } catch (e) {
                                if (e.message != `EndIterative`) throw e
                                return
                            }
                        }

                        let req1 = this.myaxios.post(`/api/Nursing/Charge/Post`, data1)
                        let req2 = this.myaxios.put(`/api/Nursing/Charge/PutMany`, data2)
                        this.myaxios
                            .all(req1, req2)
                            .then(([res1, res2]) => {
                                // 执行保存后逻辑
                                let url = this.getQueryUrl()
                                this.myaxios.post(`/api/Nursing/Charge/SaveAfter?surgeryId=${this.surgeryId}&chargetype=${this.chargeType}${url}`).then(e => {
                                    // 如果这个res有值，证明发送前校验异常，则提示并且刷新页面
                                    if (e && e != ``) {
                                        this.$alert(e, `提醒`, {
                                            dangerouslyUseHTMLString: true,
                                            type: `warning`
                                        })
                                    }
                                    if (res2 && res2 != ``) {
                                        this.$alert(res2, `提醒`, {
                                            dangerouslyUseHTMLString: true,
                                            type: `warning`
                                        })
                                    }
                                    this.$message.success(`保存成功`)
                                    this.loadChargeItems()
                                    // ACIS-24359收费时判断库存
                                    if (this.$root.IsCheckChargeStock == `1`) {
                                        let reqStock = this.myaxios.post(
                                            `/api/Nursing/Charge/CheckStock?surgeryId=${this.surgeryId}&chargeType=${this.chargeType}&sendJfType=${this.sendJfType}`,
                                            []
                                        )
                                        reqStock.then(data => {
                                            if (data && !data.status) {
                                                this.$alert(`项目库存不足:<br>` + data.msg, `提示`, {
                                                    dangerouslyUseHTMLString: true,
                                                    type: `warning`
                                                })
                                            }
                                        })
                                    }
                                    if (his == `his`) {
                                        resolve()
                                    } else {
                                        resolve(this.loadChargeItems())
                                    }
                                })
                            })
                            .catch(e => {
                                this.loadChargeItems()
                                reject(e)
                            })
                    }).catch(() => { })
                } else {
                    let data1 = this.getAdd()
                    let data2 = this.getEdit()

                    // 计费中存在相同计费项目是否提示,欢哥加的弱验证，不阻止提交
                    if (this.$root.IsChargeShowAlertHasSameItem == `1`) {
                        this.validSameItem()
                    }
                    // 计费中存在相同计费项目是否提示,肖锐加的强验证，阻止提交
                    if (this.$root.IsChargeShowAlertHasSameItem == `2`) {
                        try {
                            this.validSameItem(true)
                        } catch (e) {
                            if (e.message != `EndIterative`) throw e
                            return
                        }
                    }
                    let req1 = this.myaxios.post(`/api/Nursing/Charge/Post`, data1)
                    let req2 = this.myaxios.put(`/api/Nursing/Charge/PutMany`, data2)
                    this.myaxios
                        .all(req1, req2)
                        .then(([res1, res2]) => {
                            // 执行保存后逻辑
                            let url = this.getQueryUrl()
                            this.myaxios.post(`/api/Nursing/Charge/SaveAfter?surgeryId=${this.surgeryId}&chargetype=${this.chargeType}${url}`).then(e => {
                                // 如果这个res有值，证明发送前校验异常，则提示并且刷新页面
                                if (e && e != ``) {
                                    this.$alert(e, `提醒`, {
                                        dangerouslyUseHTMLString: true,
                                        type: `warning`
                                    })
                                }
                                if (res2 && res2 != ``) {
                                    this.$alert(res2, `提醒`, {
                                        dangerouslyUseHTMLString: true,
                                        type: `warning`
                                    })
                                }
                                this.$message.success(`保存成功`)
                                this.loadChargeItems()
                                // ACIS-24359收费时判断库存
                                if (this.$root.IsCheckChargeStock == `1`) {
                                    let reqStock = this.myaxios.post(
                                        `/api/Nursing/Charge/CheckStock?surgeryId=${this.surgeryId}&chargeType=${this.chargeType}&sendJfType=${this.sendJfType}${url}`,
                                        []
                                    )
                                    reqStock.then(data => {
                                        if (data && !data.status) {
                                            this.$alert(`项目库存不足:<br>` + data.msg, `提示`, {
                                                dangerouslyUseHTMLString: true,
                                                type: `warning`
                                            })
                                        }
                                    })
                                }
                                if (his == `his`) {
                                    resolve()
                                } else {
                                    resolve(this.loadChargeItems())
                                }
                            })
                        })
                        .catch(e => {
                            this.loadChargeItems()
                            reject(e)
                        })
                }
            })
        },
        validSameItem(force) {
            // 未发送的且类型为计费的，要判断是否项目重复，重复不允许保存
            let alllist = _.filter(this.datalist, d => d.chrg_item && d.enum_fee_type == 1 && d.enum_charge_status == 0)
            let msg = []
            alllist.forEach(n => {
                // 计费项且高值耗材编号相同判断为重复
                let exists = _.filter(this.datalist, p => p.___sequence_no != n.___sequence_no && p.enum_fee_type == 1 && p.enum_charge_status == 0 && p.chrg_item && p.chrg_item.value == n.chrg_item.value &&
                    (p.consumables_batch == n.consumables_batch || (p.consumables_batch == null && n.consumables_batch == ``) || (p.consumables_batch == `` && n.consumables_batch == null)))
                if (exists && exists.length > 0) {
                    msg.push(n.chrg_item.label)
                }
            })
            if (msg.length > 0) {
                let unitmsg = _.uniq(msg)
                this.$alert(`项目:${unitmsg.join(`,`)} 重复 请调整！`, `提示`, {
                    dangerouslyUseHTMLString: true,
                    type: `warning`
                })
                if (force) throw new Error(`EndIterative`)
            }
        },
        syncUseDrug() {
            this.syncUseDrugIn = true
            let url = this.getQueryUrl()
            let req = this.myaxios.post(`/api/Nursing/Charge/SyncUseDrug?surgeryId=${this.surgeryId}&&chargeType=${this.chargeType}${url}`)
            req.then(data => {
                // 如果这个res有值，证明发送前校验异常，则提示并且刷新页面
                if (data && data != ``) {
                    this.$alert(data, `提醒`, {
                        dangerouslyUseHTMLString: true,
                        type: `warning`
                    })
                }
                this.loadChargeItems()
            })
        },
        loadTemplates(hospitalwardid) {
            // 加载可用模板
            let that = this
            return new Promise((resolve, reject) => {
                let req = that.myaxios.get(`/api/AcisSystem/ChargeTemplate/GetTemplate?hospital_ward_id=${hospitalwardid}`)
                req.then(data => {
                    if (this.permissions && this.permissions.findIndex(item => item.permission === `tmp:area_read`) === -1 &&
                        this.permissions.findIndex(item => item.permission === `tmp:alltmp`) === -1) {
                        data = _.filter(data, x => x.owner == ((this.currentUser && this.currentUser.username) || `--`))
                    }
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        loadTemplatesView() {
            // 加载可选模板，弹出模板选择框
            this.collectCharges.selected_template = undefined
            this.collectCharges.datalist = []
            let that = this
            that.loadSurgery().then((surgery) => {
            // 加载可用模板
                let hospitalwardid = 0
                if (that.surgeryInfo && that.surgeryInfo.source_hospital_ward_id) {
                    // 这里是患者应用
                    hospitalwardid = that.surgeryInfo.source_hospital_ward_id
                }
                // else if (that.onlySimpleWard == `1`) {
                //     // 单院区过滤
                //     hospitalwardid = that.active_ward.groupId
                // }
                // 个人的时候不过滤院区
                hospitalwardid = that.region_type == 1 ? 0 : hospitalwardid
                this.loadTemplates(hospitalwardid).then(data => {
                    if (this.hasRegionTypePermission.length == 1) {
                        that.region_type = 2
                    }
                    let newchargeType = this.chargeType || 1
                    if (newchargeType == `1` || newchargeType == `201` || newchargeType == `202` || newchargeType == `203`) {
                        newchargeType = `1`
                    }

                    let isShowLeftTemplateTree = that.charge_template_group.length > 0

                    var searchResult = []
                    var ownerResult = []
                    var wardResult = []

                    data = _.filter(data, d => {
                        return d.enum_charge_type == newchargeType
                    })

                    // 模板关键字过滤
                    if (that.region_searchKey) {
                        data = _.filter(data, x => x.name.indexOf(that.region_searchKey) != -1 || x.abbr.indexOf(that.region_searchKey.toUpperCase()) != -1)
                    }

                    _.forEach(data, g => {
                        let r = { ...g }
                        if (r.owner && r.owner == this.currentUser.username) {
                            ownerResult.push(r)
                        }

                        if (!r.owner) {
                            if (!this.fromDesptop) {
                                r.dic_ward_id = r.dic_operating_ward_id && r.dic_operating_ward_id > 0 ? `ow_${r.dic_operating_ward_id}` : `rw_${r.dic_recovery_ward_id}`
                                r.dic_ward_ids = r.regions && r.regions.map(s => {
                                    return s.dic_operating_ward_id && s.dic_operating_ward_id > 0 ? `ow_${s.dic_operating_ward_id}` : `rw_${s.dic_recovery_ward_id}`
                                }) || []

                                if (hospitalwardid > 0) {
                                    // 有来源院区的直接插入
                                    wardResult.push(r)
                                } else {
                                    // 本院区的复杂些
                                    let wardids = []
                                    if (_.startsWith(that.active_ward.value, `ow_`)) {
                                        // 获取当前手术室关联的复苏室
                                        wardids = this.getOperWardLinkRecoveryIds(this.active_ward.origion)
                                    } else {
                                    // 获取当前复苏室关联的手术区
                                        wardids = this.getRecoveryOperWardIds(this.active_ward.origion)
                                    }

                                    // 获取属于当前复苏室和复苏室关联手术区的模板或者 当前手术区和手术区关联复苏室的模板
                                    let cnt = _.intersection(r.dic_ward_ids, wardids).length
                                    if (r.dic_ward_id == this.active_ward.value || cnt > 0) {
                                        wardResult.push(r)
                                    }
                                }
                            } else {
                                // 从桌面端麻醉单上tab页签进入，根据麻醉单还是复苏单，麻醉单直接拿当前手术区的模板
                                if (hospitalwardid > 0) {
                                    // 有来源院区的直接插入
                                    wardResult.push(r)
                                } else {
                                    let currentSurWardId = this.record_type == 2 ? surgery.dic_recovery_ward_id : surgery.dic_operating_ward_id
                                    let currentTempWardId = this.record_type == 2 ? r.dic_recovery_ward_id : r.dic_operating_ward_id
                                    if (currentSurWardId == currentTempWardId) {
                                        wardResult.push(r)
                                    }
                                }
                            }
                        }
                    })
                    let ts = []
                    if (isShowLeftTemplateTree) {
                        searchResult = that.region_type == 1 ? searchResult.concat(ownerResult) : searchResult.concat(wardResult)
                        let groupId = _.groupBy(searchResult, `id`)
                        ts = _.reduce(
                            groupId,
                            function(result, g, key) {
                                // 判断模板是不是复苏室模板，是复苏室模板背景色标识一下
                                let isRecoveryTemplate = false
                                if (that.region_type == 2) {
                                    var rwTemplates = _.filter(g[0].dic_ward_ids, d => _.startsWith(d, `rw_`))
                                    isRecoveryTemplate = rwTemplates && rwTemplates.length > 0
                                }

                                let r = {
                                    label: g[0].name,
                                    value: g[0].id,
                                    jianpin: g[0].abbr,
                                    code: g[0].abbr,
                                    group_id: g[0].group_id || 0,
                                    is_recovery_template: isRecoveryTemplate,
                                    display_order: g[0].display_order
                                }
                                result.push(r)
                                return result
                            },
                            []
                        )

                        let templategroups = [...that.charge_template_group]
                        templategroups.push({ value: 0, label: `其它`, children: [] })
                        let templateTree = templategroups.map(s => {
                            var pddata = _.filter(ts, d => d.group_id == parseInt(s.value))
                            s.children = _.orderBy(pddata, `display_order`)
                            return s
                        })
                        templateTree = _.filter(templateTree, x => x.children.length > 0)
                        that.templateTree.data = templateTree
                    } else {
                        searchResult = searchResult.concat(ownerResult)
                        searchResult = searchResult.concat(wardResult)
                        let groupId = _.groupBy(searchResult, `id`)
                        ts = _.reduce(
                            groupId,
                            function(result, g, key) {
                                let region = g.map(s => {
                                    let ow = s.dic_operating_ward_id && _.find(that.ward_auth, { value: `ow_${s.dic_operating_ward_id}` })
                                    let rw = s.dic_recovery_ward_id && _.find(that.ward_auth, { value: `rw_${s.dic_recovery_ward_id}` })
                                    return (ow && ow.label) || (rw && rw.label) || that.currentUser.dic_worker_name
                                })

                                let r = {
                                    label: g[0].name,
                                    value: g[0].id,
                                    jianpin: g[0].abbr,
                                    code: region.join(`,`),
                                    group: _.includes(region, that.currentUser.dic_worker_name) ? `个人模板` : `区域模板`
                                }
                                result.push(r)
                                return result
                            },
                            []
                        )
                    }

                    this.collectCharges.charge_template = _.orderBy(ts, `group`)
                    this.collectCharges.dialogFormVisible = true
                })
            })
        },
        addTemplateToList() {
            let selectedTempItems = this.checkedRow
            this.templateIn = true
            if (selectedTempItems && selectedTempItems.length > 0) {
                let data1 = _.map(this.checkedRow, d => {
                    return {
                        // "id": d.id,
                        biz_surgery_info_id: this.surgeryId,
                        enum_charge_type: this.chargeType,
                        enum_fee_type: d.enum_fee_type,
                        enum_charge_status: d.enum_charge_status,
                        dic_chrg_item_id: d.chrg_item.value,
                        dic_chrg_item_type_id: d.dic_chrg_item_type_id,
                        amount: d.amount,
                        price: d.price,
                        item_name: d.chrg_item.label,
                        // "billing_dept": "string",
                        execute_dept: d.dic_section_id && d.dic_section_id > 0 ? d.dic_section_id : null,
                        // "remark": "string",
                        // "his_code": "string",
                        // "is_sync_data": false,
                        total_price: d.total_price,
                        display_order: d.display_order,
                        sys_charge_template_id: d.sys_charge_template_id,
                        special_medication_remark: d.charge_item && d.charge_item.remark || `` // 27186 ，有特殊用药
                    }
                })
                let req1 = this.myaxios.post(`/api/Nursing/Charge/Post?isTemplate=1`, data1)
                req1.then((data) => {
                    // 如果这个res有值，证明发送前校验异常，则提示并且刷新页面
                    if (data && data.length > 0 && data[0].notifymessage) {
                        let notify = data[0].notifymessage
                        this.$alert(notify, `提醒`, {
                            dangerouslyUseHTMLString: true,
                            type: `warning`
                        })
                    }

                    this.collectCharges.dialogFormVisible = false
                    // ACIS-24398应用计费模板后，删除计费项错误
                    this.checkedRow = []
                    this.loadChargeItems()
                }).catch(e => {
                    this.checkedRow = []
                    this.loadChargeItems()
                })
            } else {
                this.$message.warning(`未选择计费项`)
                return false
            }
        },
        // 获取手术区关联的复苏区
        getOperWardLinkRecoveryIds(operatingid) {
            let that = this
            let linkRecoveryIds = []
            for (var i = 0; i < that.recovery_ward_all.length; i++) {
                let cur = that.recovery_ward_all[i]
                if (cur.dic_operating_ward_ids && _.includes(cur.dic_operating_ward_ids, operatingid)) {
                    linkRecoveryIds.push(`rw_${cur.id}`)
                }
            }
            return linkRecoveryIds
        },
        // 获取复苏室关联的手术区
        getRecoveryOperWardIds(recoveryid) {
            let that = this
            let r = _.find(that.recovery_ward_all, { id: recoveryid })
            return (r && r.dic_operating_ward_ids && r.dic_operating_ward_ids.map(d => {
                return `ow_${d}`
            })) || []
        },
        // 处理库存逻辑
        saveInventory(inventorytype) {
            console.log(inventorytype)
            let sendrow = this.checkedRow
            let nosave = _.filter(sendrow, d => d.chrg_item && d.chrg_item.value && !d.id)
            if (nosave != null && nosave.length > 0) {
                this.$message.warning(`请先保存！`)
                return
            }
            var pddata = []
            let msg = `扣库存`
            if (inventorytype == 2) {
                msg = `取消扣库存`
                pddata = _.filter(sendrow, d => d.chrg_item && d.chrg_item.value && d.dic_chrg_item_type_id == 1 && d.is_deducted_inventory == 1)
            } else if (inventorytype == 1) {
                pddata = _.filter(sendrow, d => d.chrg_item && d.chrg_item.value && d.dic_chrg_item_type_id == 1 && d.is_deducted_inventory == 0)
            }
            console.log(pddata)
            if (pddata && pddata.length == 0) {
                this.$message.warning(`没有药品数据，可以${msg}`)
                return
            }
            console.log(pddata)
            this.$confirm(`是否确定${msg}?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.post(
                    `/api/Nursing/Charge/saveInventory?surgeryId=${this.surgeryId}&chargeType=${this.chargeType}&inventorytype=${inventorytype}`,
                    _.map(pddata, d => d.id)
                )
                req.then((res) => {
                    this.$message.success(`${msg}成功!`)
                    this.loadChargeItems()
                })
            })
        },
        sendHis() {
            let sendrow = this.checkedRow
            var savedata = _.filter(this.datalist, d => d.chrg_item && d.chrg_item.value)
            // url 过滤 模板加载计费项类型
            let url = this.getQueryUrl()
            this.saveItems(`his`).then(() => {
                if (this.sendJfType == `1`) {
                    if (!savedata || savedata.length == 0) {
                        this.$message.warning(`没有可以发送的数据`)
                        this.loadChargeItems()
                        return
                    }
                    this.$confirm(`是否确认发送?`, `发送操作`, {
                        confirmButtonText: `确定`,
                        cancelButtonText: `取消`,
                        closeOnClickModal: false
                    }).then(() => {
                        let req = this.myaxios.post(
                            `/api/Nursing/Charge/SubmitJF?surgeryId=${this.surgeryId}&chargeType=${this.chargeType}&sendJfType=${this.sendJfType}${url}`,
                            []
                        )
                        req.then((res) => {
                            if (res && res != ``) {
                                this.$alert(res, `提醒`, {
                                    dangerouslyUseHTMLString: true,
                                    type: `warning`
                                }).then(data => {
                                    this.loadChargeItems()
                                }).catch(this.loadChargeItems())
                                return
                            }
                            this.$message.success(`已发送`)
                            this.loadChargeItems()
                        })
                    }).catch(() => {})
                } else {
                    // 勾选发送取页面勾选有效数据进行发送
                    // 这里增加一个判断逻辑。保存后如果有新增的数据，则提示客户让他重新勾选,并且刷新页面（保存后页面未刷新id未生成场景导致异常）
                    let dataadd = this.getAdd()
                    console.log(dataadd)
                    if (dataadd && dataadd.length > 0) {
                        this.$alert(`您有未保存的数据，已为您执行保存，请重新勾选发送`, `提醒`, {
                            dangerouslyUseHTMLString: true,
                            type: `warning`
                        }).then(data => {
                            this.loadChargeItems()
                        }).catch(this.loadChargeItems())
                        return
                    }

                    let data1 = _.filter(sendrow, d => (d.enum_charge_status == 0 || d.enum_charge_status == 2) && d.enum_fee_type == 1) // 收费+待审核
                    if (!data1 || data1.length == 0) {
                        this.$message.warning(`没有可以发送的数据`)
                        this.loadChargeItems()
                        return
                    }
                    this.$confirm(`是否确认发送?`, `发送操作`, {
                        confirmButtonText: `确定`,
                        cancelButtonText: `取消`,
                        closeOnClickModal: false
                    }).then(() => {
                        let req = this.myaxios.post(
                            `/api/Nursing/Charge/SubmitJF?surgeryId=${this.surgeryId}&chargeType=${this.chargeType}&sendJfType=${this.sendJfType}${url}`,
                            _.map(data1, d => d.id)
                        )
                        req.then((res) => {
                            if (res && res != ``) {
                                this.$alert(res, `提醒`, {
                                    dangerouslyUseHTMLString: true,
                                    type: `warning`
                                }).then(data => {
                                    this.loadChargeItems()
                                }).catch(this.loadChargeItems())
                                return
                            }
                            this.$message.success(`已发送`)
                            this.loadChargeItems()
                        })
                    }).catch(() => {})
                }
            })
                .catch(e => {
                    console.log(e)
                })
        },
        printChargeItems() {
            let docId = this.$root.DOCUMENT[`MZJF001`]
            let obj = {
                docid: docId,
                chargeType: this.chargeType,
                id1: this.surgeryId
            }
            if (this.$route.query.charge_item_types) {
                obj.objId = this.$route.query.charge_item_types
            }
            this.saveItems().then(() => {
                let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
                req2.then(isShow => {
                    this.$store.dispatch(`PRINT_PDF`, {
                        host: this.$root.DOCSERVICE_BASE,
                        params: Object.assign(
                            obj,
                            { isShowSendPrintMessage: isShow.value }
                        )
                    })
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        printChargeAllItems(isHC = null) {
            let docId = !isHC ? this.$root.DOCUMENT[`MZJF010`] : this.$root.DOCUMENT[`MZHCJFPrint`]
            let obj = {
                docid: docId,
                chargeType: this.chargeType,
                id1: this.surgeryId
            }
            if (this.$route.query.charge_item_types) {
                obj.objId = this.$route.query.charge_item_types
            }
            this.saveItems().then(() => {
                let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
                req2.then(isShow => {
                    this.$store.dispatch(`PRINT_PDF`, {
                        host: this.$root.DOCSERVICE_BASE,
                        params: Object.assign(
                            obj,
                            { isShowSendPrintMessage: isShow.value }
                        )
                    })
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        printByChargeItemType() {
            let docId = 0
            let settings = []
            if (this.chargeItemTypePrintSetting) {
                settings = JSON.parse(this.chargeItemTypePrintSetting)
                let types = this.$route.query.charge_item_types || ``
                let settDoc = settings && _.find(settings, { charge_item_types: types }) || null
                docId = settDoc && settDoc.docid || 0
            }
            if (docId == 0) {
                this.$message.warning(`参数ChargeItemTypePrintSetting 没有设置对应文书`)
                return
            }
            let obj = {
                docid: docId,
                chargeType: this.chargeType,
                id1: this.surgeryId
            }
            if (this.$route.query.charge_item_types) {
                obj.objId = this.$route.query.charge_item_types
            }
            this.saveItems().then(() => {
                let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
                req2.then(isShow => {
                    this.$store.dispatch(`PRINT_PDF`, {
                        host: this.$root.DOCSERVICE_BASE,
                        params: Object.assign(
                            obj,
                            { isShowSendPrintMessage: isShow.value }
                        )
                    })
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        SaveAsTemplate() {
            let tmpldatalist = _.filter(this.datalist, x => x.chrg_item && x.chrg_item.value && x.enum_fee_type == 1)
            if (!tmpldatalist || tmpldatalist.length == 0) {
                this.$message.warning(`没有可以存为模板的计费项，可请刷新后重试`)
                return
            }
            this.saveas.dialogFormVisible = true
        },
        withdrawHis() {
            if (this.chargeRefundType == 1) {
                this.$confirm(`是否确认撤销?`, `撤销操作`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`
                }).then(() => {
                    let url = this.getQueryUrl()
                    let req = this.myaxios.post(
                        `/api/Nursing/Charge/SubmitWithdraw?surgeryId=${this.surgeryId}&chargeType=${this.chargeType}&chargeRefundType=1${url}`,
                        []
                    )
                    req.then(() => {
                        this.$message.success(`已发送`)
                        this.loadChargeItems()
                    })
                }).catch(() => {})
            } else {
                let data1 = _.filter(this.checkedRow, d => d.enum_charge_status == 10 && d.enum_fee_type == 1) // 收费+待审核
                if (!data1 || data1.length == 0) {
                    this.$message.warning(`没有可以撤销的数据`)
                    return
                }
                this.$confirm(`是否确认撤销?`, `撤销操作`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`
                }).then(() => {
                    let url = this.getQueryUrl()
                    let req = this.myaxios.post(
                        `/api/Nursing/Charge/SubmitWithdraw?surgeryId=${this.surgeryId}&chargeType=${this.chargeType}&chargeRefundType=${this.chargeRefundType}${url}`,
                        _.map(data1, d => d.id)
                    )
                    req.then(() => {
                        this.$message.success(`已发送`)
                        this.loadChargeItems()
                    })
                }).catch(() => {})
            }
        },
        loadReturnCharges() {
            if (this.chargeRefundType == 1) {
                this.$confirm(`是否确认退费?`, `退费操作`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`
                }).then(() => {
                    let url = this.getQueryUrl()
                    this.myaxios.post(
                        `/api/Nursing/Charge/SubmitTF?surgeryId=${this.surgeryId}&chargeType=${this.chargeType}&chargeRefundType=1${url}`,
                        []
                    ).then(res => {
                        if (res && res != ``) {
                            this.$alert(res, `提醒`, {
                                dangerouslyUseHTMLString: true,
                                type: `warning`
                            }).then(data => {
                                this.loadChargeItems()
                            }).catch(this.loadChargeItems())
                            return
                        }
                        this.$message.success(`已发送`)
                        this.loadChargeItems()
                    })
                }).catch(() => {})
            } else {
                let data1 = _.filter(this.checkedRow, d => (d.enum_charge_status == 1 || d.enum_charge_status == 4) && d.enum_fee_type == 1) // 收费+计费成功
                if (!data1 || data1.length == 0) {
                    this.$message.warning(`未找到可以退费的数据`)
                    return
                }
                this.$confirm(`是否确认退费?`, `退费操作`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`
                }).then(() => {
                    let url = this.getQueryUrl()
                    let req = this.myaxios.post(
                        `/api/Nursing/Charge/SubmitTF?surgeryId=${this.surgeryId}&chargeType=${this.chargeType}&chargeRefundType=${this.chargeRefundType}${url}`,
                        _.map(data1, d => d.id)
                    )
                    req.then((res) => {
                        if (res && res != ``) {
                            this.$alert(res, `提醒`, {
                                dangerouslyUseHTMLString: true,
                                type: `warning`
                            }).then(data => {
                                this.loadChargeItems()
                            }).catch(this.loadChargeItems())
                            return
                        }
                        this.$message.success(`已发送`)
                        this.loadChargeItems()
                    })
                }).catch(() => {})
            }
        },
        returnCharges() {
            let data1 = _.map(_.filter(this.returnChargesView.datalist, `checked`), d => {
                return {
                    // "id": d.id,
                    biz_surgery_info_id: this.surgeryId,
                    enum_charge_type: this.chargeType,
                    enum_fee_type: -1,
                    enum_charge_status: 0,
                    enum_pay_type: d.enum_pay_type,
                    dic_chrg_item_id: d.chrg_item.value,
                    amount: d.amount,
                    price: d.price,
                    // "billing_dept": "string",
                    execute_dept: d.execute_dept,
                    // "remark": "string",
                    // "his_code": "string",
                    // "is_sync_data": false,
                    total_price: d.total_price,
                    biz_charge_detail_id: d.id
                }
            })
            let req1 = this.myaxios.post(`/api/Nursing/Charge/Post`, data1)
            req1.then((data) => {
                if (data && data.length > 0 && data[0].notifymessage) {
                    let notify = data[0].notifymessage
                    this.$alert(notify, `提醒`, {
                        dangerouslyUseHTMLString: true,
                        type: `warning`
                    })
                }
                this.returnChargesView.dialogFormVisible = false
                this.loadChargeItems()
            }).catch(e => {
                this.loadChargeItems()
            })
        },
        loadConfigs() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/Get`)
                let req1 = this.myaxios.get(`/api/AcisSystem/Section/Get`)
                this.myaxios.all(req, req1).then(([data, data1]) => {
                    let config = _.filter(data, { key: `ChargeItemCodeConfig` })[0] && _.filter(data, { key: `ChargeItemCodeConfig` })[0].value
                    let refundType = _.filter(data, { key: `ChargeRefundType` })[0] && _.filter(data, { key: `ChargeRefundType` })[0].value
                    let isMultiScreen = _.filter(data, { key: `IsMultiScreen` })[0] && _.filter(data, { key: `IsMultiScreen` })[0].value
                    this.isMultiScreen = isMultiScreen == 1
                    this.setMultiScreen = getScreensData(this.isMultiScreen)
                    if (refundType) {
                        this.chargeRefundType = refundType
                    }
                    let selectedConfig = _.filter(data, { key: `ChargeTemplateSelected` })[0] && _.filter(data, { key: `ChargeTemplateSelected` })[0].value
                    if (selectedConfig) {
                        this.charge_template_selected = selectedConfig
                    }
                    this.item_configs = config.split(`|`)
                    this.setChargeColumns()
                    resolve(config)
                })
            })
        },
        setChargeColumns() {
            let that = this
            let resultColumns = [
                { prop: `name`, label: `项目名称`, minWidth: 250, fixed: `left` }
            ]
            that.item_configs.forEach(item => {
                let codeInfo = _.find(that.chargeColumns, { id: item })
                if (codeInfo) {
                    resultColumns.push(codeInfo)
                }
            })
            console.log(resultColumns)
            this.chargeColumns = resultColumns
        },
        loadChargeItemList(q) {
            let url = this.getQueryUrl()
            return new Promise(resolve => {
                let req = this.myaxios.get(`api/AcisSystem/ChargeItem/SearchForChargeNewProc?keyword=${q && q.keyword}&surgeryId=${this.surgeryId}${url}`)
                req.then(data => {
                    data = _.map(data, d => {
                        let codes = []
                        // (0-编码,1-规格,2-价格,3-单位,4-厂商,5-统一收费编码,6-医保类型,7-库存,8-描述)
                        for (let item of this.item_configs) {
                            if (item === `0`) {
                                codes.push(d.code)
                            }
                            if (item === `1`) {
                                codes.push(d.spec || `--`)
                            }
                            if (item === `2`) {
                                codes.push(d.price || `--`)
                            }
                            if (item === `3`) {
                                codes.push(d.sell_unit || `--`)
                            }
                            if (item === `4`) {
                                codes.push(d.firm || `--`)
                            }
                            if (item === `5`) {
                                codes.push(d.uni_charge_code || `--`)
                            }
                            if (item === `6`) {
                                codes.push(d.medical_type || `--`)
                            }
                            if (item === `7`) {
                                codes.push(`库存:${d.inventory || `--`}`)
                            }
                            if (item === `8`) {
                                codes.push(d.description || `--`)
                            }
                        }
                        return {
                            ...d,
                            value: d.id,
                            label: d.name,
                            abbr: d.abbr,
                            code: codes.join(`/`)
                        }
                    })
                    resolve(data)
                })
            })
        },
        loadChargeItemTypes() {
            return new Promise((resolve, reject) => {
                this.myaxios.get(`/api/AcisSystem/ChargeItem/SearchType`)
                    .then(data => {
                        if (this.queryChargeItemTypeIds && this.queryChargeItemTypeIds.length > 0) {
                            this.charge_item_types = data.filter(d => {
                                return _.includes(this.queryChargeItemTypeIds, d.value)
                            })
                        } else {
                            this.charge_item_types = data
                        }
                        resolve(this.charge_item_types)
                    })
            })
        },
        getChargeItemTypeName(id) {
            let item = _.find(this.charge_item_types, x => x.value == id)
            if (item) { return item.label || `` }
            return ``
        },
        getGroupNameById(id) {
            let item = _.find(this.charge_template_group, x => x.value == id)
            if (item) { return item.label || `` }
            return `其它`
        },
        loadWorker(q, row) {
            // todo:是否需要判断手术区的员工
            let r = {
                // operatingWardId: (this.active_ward && this.active_ward.value.split(`_`)[1]),
                operatingWardId: 0,
                keyword: q && q.keyword
            }
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Worker/SearchForChargeNew`, r)
                req.then(data => {
                    console.log(`SearchForChargeNew`)

                    console.log(data)
                    resolve(data)
                })
            })
        },
        LoadUserColumns() {
            let that = this
            let req = this.myaxios.get(`api/AcisSystem/SystemServer/GetColumnConfig?tableName=${that.tableName}`)
            req.then(data => {
                let lcs = _.orderBy(this.columnList, function(lc) {
                    return _.findIndex(data, { col_name: lc.prop })
                })
                this.configColumns = lcs.filter(d => {
                    return d.label != `unique` && d.isListable !== false
                }).map(c => {
                    return { value: c.prop, label: c.label }
                })
                this.user_config_columns = (data && _.filter(data, { enabled: true }).map(d => d.col_name)) || []
                this.user_config_columns2 = data && _.filter(data, { enabled: true }).map(d => {
                    return {
                        col_name: d.col_name,
                        col_width: d.col_width
                    }
                }) || []
            })
        },
        SaveUserColumns() {
            let that = this
            let uc = this.configColumns.map((c, index) => {
                return {
                    col_name: c.value,
                    display_order: index,
                    enabled: _.includes(this.user_config_columns, c.value),
                    table_name: that.tableName
                }
            })
            let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnConfig`, uc)
            req.then(data => {
                this.$message.success(`保存成功`)
                if (this.reload) {
                    this.reload()
                }
            }).catch(e => {})
        },
        configColumnDrop() {
            // if (!this.columnConfig) return
            const tbody = document.querySelector(`.config-column .el-checkbox-group`)
            const _this = this
            Sortable.create(tbody, {
                group: { name: `config-columns`, push: false, put: false },
                animation: 180,
                fallbackOnBody: true,
                delay: 0,
                onUpdate({ newIndex, oldIndex }) {
                    // 交换排序
                    if (newIndex == oldIndex) return
                    // console.log({ newIndex, oldIndex })
                    const currRow = _this.configColumns.splice(oldIndex, 1)[0]
                    _this.configColumns.splice(newIndex, 0, currRow)
                }
            })
        },
        DisplayOrderNumber(str) {
            let that = this
            let r = _.find(that.charge_item_types, { value: str })
            return (r && r.display_order) || 10000
        },
        scanCharge() {
            let that = this
            var savedata = _.filter(this.datalist, d => d.chrg_item && d.chrg_item.value && (!d.id || d.id < 0))
            if (savedata.length > 0) {
                this.$message.warning(`请先保存计费项`)
                return
            }
            if (!that.scancode) {
                that.$message.warning(`请输入或扫码`)
                return
            }
            console.log(`条码扫码枪`)
            console.log(this.datalist)
            let predata = null

            if (this.defaultPrevRow > `0` && this.datalist.length >= 2) {
                let r = this.datalist[this.datalist.length - 2]
                if (this.defaultPrevRow == `1`) {
                    predata = {
                        billing_dept: r.billing_dept && r.billing_dept.value,
                        doctor: r.doctor && r.doctor.value
                    }
                } else if (this.defaultPrevRow == `2`) {
                    predata = {
                        billing_dept: r.billing_dept && r.billing_dept.value,
                        execute_dept: r.execute_dept && r.execute_dept.value,
                        doctor: r.doctor && r.doctor.value
                    }
                }
            }

            let req = that.myaxios.post(`/api/Nursing/Charge/ChargeScan?barcode=${that.scancode.trim()}&surgeryId=${that.surgeryId}&chargeType=${that.chargeType}`, predata)
            req.then(data => {
                that.scancode = ``
                that.loadChargeItems()
                that.$refs[`scan-code`].scan_val = ``
                that.$message.success(`扫码成功`)
                that.$nextTick(() => {
                    that.$refs[`supplies-list`].scrollToBottom()
                })
            }).catch(e => {
                that.$message.error(e)
            })
        },
        changeColWidthBody(nw, ow, col, evt) {
            if (nw < 20) {
                nw = 20
            } else if (nw > 500) {
                nw = 500
            }
            let r = {
                col_name: col.property,
                col_width: parseInt(nw),
                table_name: this.tableName
            }
            let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnWidth`, r)
            req.then(data => {
                this.$message.success(`列宽调整成功`)
                // if (this.reload) {
                //     this.reload()
                // }
            }).catch(e => {})
        },
        changeColWidth(nw, ow, col, evt) {
            let that = this
            // 列宽值改变则post列宽
            if (this.user_config_columns2.length == 0) {
                let uc = this.configColumns.map((c, index) => {
                    return {
                        col_name: c.value,
                        display_order: index,
                        enabled: _.includes(this.user_config_columns, c.value),
                        table_name: this.tableName
                    }
                })
                let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnConfig`, uc)
                req.then(data => {
                    that.LoadUserColumns().then(d => {
                        that.changeColWidthBody(nw, ow, col, evt)
                    })
                }).catch(e => { })
            } else {
                that.changeColWidthBody(nw, ow, col, evt)
            }
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.getReload()
        },
        'collectCharges.selected_template': function(newval, oldval) {
            // 加载已选模板详情
            if (!newval) return
            let that = this
            let req = that.myaxios.get(`/api/AcisSystem/ChargeTemplate/Get/${newval}`)
            req.then(template => {
                let r = _.map(template.items, d => {
                    d.enum_fee_type = 1
                    d.enum_charge_status = 0
                    d.total_price = 1.0 * d.charge_item.price
                    d.spec = d.charge_item.spec
                    d.firm = d.charge_item.firm
                    d.sell_unit = d.charge_item.sell_unit
                    d.price = d.charge_item.price
                    d.dic_chrg_item_type_id = d.dic_chrg_item_type_id
                    d.dic_chrg_item_type_name = this.getChargeItemTypeName(d.dic_chrg_item_type_id)
                    d.dic_chrg_item_name = d.charge_item.name
                    d.chrg_item = {
                        label: d.charge_item.name,
                        value: d.charge_item.id
                    }
                    d.dic_section_id = d.dic_section_id
                    if (d.dic_section_id && d.dic_section_id > 0) {
                        d.execute_dept = this.getSectionById(d.dic_section_id)
                    }
                    return d
                })
                that.collectCharges.datalist = _.orderBy(r, `display_order`)
                this.$nextTick(function() {
                    if (this.charge_template_selected && this.charge_template_selected === `1`) {
                        this.$refs.collectChargeslist.selectAll(true)
                    }
                })
            })
        },
        charge_item_type: function() {
            this.loadChargeItems()
        },
        status: function() {
            this.loadChargeItems()
        },
        fee_type: function() {
            this.loadChargeItems()
        },
        region_type: function() {
            this.loadTemplatesView()
        }
    }
}
</script>
<style lang="less">
// 覆盖层元素增加可穿透点击事件
.el-dialog__wrapper {
    pointer-events: none;
}
// 弹窗层元素不可穿透点击事件（不影响弹窗层元素的点击事件）
.el-dialog {
    pointer-events: auto;
}
.config-column {
    width: 150px;
    overflow: hidden;
    margin: 20px 0;
}
.config-column .el-checkbox-group .el-checkbox {
    display: table-row;
}
.fontredtip td {
    color: rgb(252, 164, 164);
}
.fontbluetip td {
    color: hsl(216deg 87% 69%);
}

.fontred td {
    color: red;
}
.fontorange td {
    color: orange;
}
.fontyellow td {
    color: yellow;
}
.fontgreen td {
    color: green;
}
.fontCyan td {
    color: Cyan;
}
.fontblue td {
    color: blue;
}
.fontpurple td {
    color: purple;
}
td.is-center.chrg_item.el-table__cell {
    text-align: left !important;
    padding-left: 10px !important;
}
td.is-center.firm.el-table__cell {
    text-align: left !important;
    padding-left: 10px !important;
}
td.is-center.chrg_item.el-table__cell .ellipsis {
    width: 90% !important;
}
td.is-center.firm.el-table__cell .ellipsis {
    width: 90% !important;
}
td.is-center.chrg_item.el-table__cell .el-select {
    padding-right: 10px !important;
}
td.is-center.firm.el-table__cell .el-select {
    padding-right: 10px !important;
}
.charge-row {
    color: var(--rowcolor) !important;
    background: var(--rowbgcolor) !important;
    font-weight: bold;
    &:hover {
        color: var(--hoverRowcolor) !important;
        background: var(--hoverRowbgcolor) !important;
        font-weight: bold;
    }
    .special_medication_remark {
        color: red !important;
        input {
                color: red !important;
        }
    }
}
.charge-row :hover td {
    background: none !important;
}
.fontYP {
    color: var(--YPColor) !important;
}
.fontZL {
    color: var(--ZLColor) !important;
}
.fontQT {
    color: var(--QTColor) !important;
}
.fontHY {
    color: var(--HYColor) !important;
}
.fontJC {
    color: var(--JCColor) !important;
}
.fontZC {
    color: var(--ZCColor) !important;
}
.fontSS {
    color: var(--SSColor) !important;
}
.fontXF {
    color: var(--XFColor) !important;
}
.fontCL {
    color: var(--CLColor) !important;
}
.fontHL {
    color: var(--HLColor) !important;
}
.fontDZHC {
    color: var(--DZHCColor) !important;
}

.fontFYP {
    color: var(--FYPColor) !important;
}
.fontHC {
    color: var(--HCColor) !important;
}
.fontGZHC {
    color: var(--GZHCColor) !important;
}
.fontYPAmounOver .amount {
    color: var(--YPAmountColor) !important;
}
.fontZLAmounOver .amount {
    color: var(--ZLAmountColor) !important;
}
.fontQTAmounOver .amount {
    color: var(--QTAmountColor) !important;
}
.fontHYAmounOver .amount {
    color: var(--HYAmountColor) !important;
}
.fontJCAmounOver .amount {
    color: var(--JCAmountColor) !important;
}
.fontZCAmounOver .amount {
    color: var(--ZCAmountColor) !important;
}
.fontSSAmounOver .amount {
    color: var(--SSAmountColor) !important;
}
.fontXFAmounOver .amount {
    color: var(--XFAmountColor) !important;
}
.fontCLAmounOver .amount {
    color: var(--CLAmountColor) !important;
}
.fontHLAmounOver .amount {
    color: var(--HLAmountColor) !important;
}
.fontDZHCAmounOver .amount {
    color: var(--DZHCAmountColor) !important;
}
.fontFYPAmounOver .amount {
    color: var(--FYPAmountColor) !important;
}
.fontHCAmounOver .amount {
    color: var(--HCAmountColor) !important;
}
.fontGZHCAmounOver .amount {
    color: var(--GZHCAmountColor) !important;
}

.fontpayTypeNull {
    color: var(--payTypeNullColor) !important;
}
.fontamountZero {
    color: var(--amountZeroColor) !important;
}
.fontamounOver .amount {
    color: var(--amountOverColor) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Charge/Index.vue